// functions.js
import React, { useEffect } from "react";

import {
  doc,
  updateDoc,
  addDoc,
  query,
  Timestamp,
  collection,
  getDocs,
  where,
  orderBy,
  increment,
  setDoc,
  getDoc,
} from "firebase/firestore";
import { db } from "./firebase"; // Se till att du importerar din Firebase-instans korrekt
import { formatDistanceToNow, format } from "date-fns";
import { sv } from "date-fns/locale";
import PrintIcon from "@mui/icons-material/Print";
import GenerateIcon from "@mui/icons-material/AutoAwesome";
import ImageIcon from "@mui/icons-material/Image";
import Logger from "./Logger";

import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import ShieldIcon from "@mui/icons-material/VerifiedUser";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import EditIcon from "@mui/icons-material/Edit";
import GoogleIcon from "@mui/icons-material/Google";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import TimelineIcon from "@mui/icons-material/Timeline"; // Add this import
import ChatIcon from "@mui/icons-material/Chat";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import EmailIcon from "@mui/icons-material/Email";
import { useNavigate } from "react-router-dom";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import PowerPointIcon from "./PowerPointIcon";

import GridViewIcon from "@mui/icons-material/GridView";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import LanguageIcon from "@mui/icons-material/Language";
import LockIcon from "@mui/icons-material/Lock";
import BlurOnIcon from "@mui/icons-material/BlurOn";
import QuizIcon from "@mui/icons-material/Quiz";
import StopScreenShareIcon from "@mui/icons-material/StopScreenShare";
import SchoolIcon from "@mui/icons-material/School";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import AssessmentIcon from "@mui/icons-material/Assessment";
import Slide from "@mui/material/Slide";
import { forwardRef } from "react";
import KeyboardIcon from "@mui/icons-material/Keyboard";
import PodcastsIcon from "@mui/icons-material/Podcasts";
import StarIcon from "@mui/icons-material/Star";
import ShareIcon from "@mui/icons-material/Share";
import CreateIcon from "@mui/icons-material/Create";

import WordIcon2019 from "./WordIcon2019";
import { darken, lighten } from "@mui/material/styles";
import ViewAgendaIcon from "@mui/icons-material/ViewAgenda";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import MemoryIcon from "@mui/icons-material/Memory";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import { Helmet } from "react-helmet-async";
// **Newly Added Icon Imports**
import ForumIcon from "@mui/icons-material/Forum";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import PsychologyIcon from "@mui/icons-material/Psychology";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import SettingsIcon from "@mui/icons-material/Settings";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TranslateIcon from "@mui/icons-material/Translate";
import BuildIcon from "@mui/icons-material/Build";
import AccessibilityNewIcon from "@mui/icons-material/AccessibilityNew";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import GTranslateIcon from "@mui/icons-material/GTranslate";
import GradeIcon from "@mui/icons-material/Grade";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import SpellcheckIcon from "@mui/icons-material/Spellcheck";
import SaveIcon from "@mui/icons-material/Save";
import MenuBookIcon from "@mui/icons-material/MenuBook"; // **Added Import**

import FingerprintIcon from "@mui/icons-material/Fingerprint";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import TransformIcon from "@mui/icons-material/Transform";
import TuneIcon from "@mui/icons-material/Tune";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CategoryIcon from "@mui/icons-material/Category";

import AccessTimeIcon from "@mui/icons-material/AccessTime";
import BalanceIcon from "@mui/icons-material/Balance";
import FolderIcon from "@mui/icons-material/Folder";
import SpeedIcon from "@mui/icons-material/Speed";

import PeopleIcon from "@mui/icons-material/People";

import ShuffleIcon from "@mui/icons-material/Shuffle";
import SummarizeIcon from "@mui/icons-material/Summarize";
import AssignmentIcon from "@mui/icons-material/Assignment";

import TextFieldsIcon from "@mui/icons-material/TextFields";
import CompressIcon from "@mui/icons-material/Compress";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import ExpandIcon from "@mui/icons-material/Expand";

import GavelIcon from "@mui/icons-material/Gavel";
import LinkIcon from "@mui/icons-material/Link";
import RepeatIcon from "@mui/icons-material/Repeat";
import AnalyticsIcon from "@mui/icons-material/Analytics";

import RateReviewIcon from "@mui/icons-material/RateReview";
import ViewStreamIcon from "@mui/icons-material/ViewStream";

import UpdateIcon from "@mui/icons-material/Update";
import HistoryIcon from "@mui/icons-material/History";

import BarChartIcon from "@mui/icons-material/BarChart";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";

import BrushIcon from "@mui/icons-material/Brush";
import LocalFloristIcon from "@mui/icons-material/LocalFlorist";

import SentimentVerySatisfiedIcon from "@mui/icons-material/SentimentVerySatisfied";
import TheaterComedyIcon from "@mui/icons-material/TheaterComedy";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import { serverTimestamp } from "firebase/firestore";
// imageGenerator.js
import { generateImage } from "./api";
import CheckIcon from "@mui/icons-material/Check";
import {
  FormControlLabel,
  Typography,
  Checkbox,
  Button,
  IconButton,
} from "@mui/material";
import { CheckCircle, RadioButtonUnchecked } from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import { getStyles } from "../index";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

export function escapeLatexInJson(jsonString) {
  // Find all LaTeX expressions (between $ signs) and double-escape all backslashes
  return jsonString.replace(
    /(\$\$?)(.*?)(\$\$?)/g,
    (match, open, content, close) => {
      const escapedContent = content.replace(/\\/g, "\\\\");
      return open + escapedContent + close;
    },
  );
}

export const fixLatexNotation = (text) => {
  if (!text) return text;

  // Regex för att hitta innehåll mellan $ och $ eller $$ och $$
  const inlineMathRegex = /\$(.*?)\$/g;
  const displayMathRegex = /\$\$(.*?)\$\$/g;

  // Funktion för att ersätta dubbla backslashar med enkla inom matchningar
  const replaceBackslashes = (match, content, delimiter) => {
    const fixedContent = content.replace(/\\\\([a-zA-Z]+)/g, "\\$1");
    return delimiter + fixedContent + delimiter;
  };

  // Fixa både inline och display math
  let fixedText = text.replace(inlineMathRegex, (match, content) =>
    replaceBackslashes(match, content, "$"),
  );

  fixedText = fixedText.replace(displayMathRegex, (match, content) =>
    replaceBackslashes(match, content, "$$"),
  );

  return fixedText;
};

export const beautifyGradeText = (grade) => {
  if (!grade) return "";

  // Handle "åk" grades (åk1-åk9)
  if (grade.startsWith("åk")) {
    const number = grade.substring(2);
    return `Åk ${number}`;
  }

  // Handle gymnasium grades
  if (grade === "firstRing") return "Gymnasiet 1:a ring";
  if (grade === "secondRing") return "Gymnasiet 2:a ring";
  if (grade === "thirdRing") return "Gymnasiet 3:e ring";

  // For any other format, return as is with first letter capitalized
  return grade.charAt(0).toUpperCase() + grade.slice(1);
};

export const subjectVideos = {
  religionskunskap: [
    {
      title: "Kristendomen förklarad",
      url: "https://www.youtube.com/watch?v=ors0kV6oR-4&list=PLSHcVfKvOzQMGlNJOG_j_OAzyiU8ytC0O&index=1&pp=iAQB",
      channel: "URPLAY",
    },
    {
      title: "Islam förklarad",
      url: "https://www.youtube.com/watch?v=kBROYF3K4Zw&list=PLSHcVfKvOzQMGlNJOG_j_OAzyiU8ytC0O&index=2&t=2s&pp=iAQB",
      channel: "URPLAY",
    },
    {
      title: "Hindiusmen förklarad",
      url: "https://www.youtube.com/watch?v=q_A2QYRb0pA&list=PLSHcVfKvOzQMGlNJOG_j_OAzyiU8ytC0O&index=4&pp=iAQB",
      channel: "URPLAY",
    },
    {
      title: "Buddhismen förklarad",
      url: "https://www.youtube.com/watch?v=88jkPXCa0L8&list=PLSHcVfKvOzQMGlNJOG_j_OAzyiU8ytC0O&index=5&pp=iAQB",
      channel: "URPLAY",
    },
    {
      title: "Sveriges sekularisering förklarad",
      url: "https://www.youtube.com/watch?v=G5t-O3ww_7s&list=PLSHcVfKvOzQMGlNJOG_j_OAzyiU8ytC0O&index=3&pp=iAQB",
      channel: "URPLAY",
    },
  ],
  historia: [
    {
      title: "Antiken",
      url: "https://www.youtube.com/watch?v=J-jOuUL-ZOw&list=PLSHcVfKvOzQMzKwqRJaL0tWHO8Gy-YdnG&index=1&pp=iAQB",
      channel: "URPLAY",
    },
    {
      title: "Medeltiden",
      url: "https://www.youtube.com/watch?v=7MailENdgx4&list=PLSHcVfKvOzQMzKwqRJaL0tWHO8Gy-YdnG&index=2&t=233s&pp=iAQB",
      channel: "URPLAY",
    },
    {
      title: "Stormaktstiden",
      url: "https://www.youtube.com/watch?v=zi5NImWqto8&list=PLSHcVfKvOzQMzKwqRJaL0tWHO8Gy-YdnG&index=5&pp=iAQB",
      channel: "URPLAY",
    },

    {
      title: "Socialismens framväxt",
      url: "https://www.youtube.com/watch?v=bIMYUH8f0e4&list=PLSHcVfKvOzQMzKwqRJaL0tWHO8Gy-YdnG&index=13&pp=iAQB",
      channel: "URPLAY",
    },
    {
      title: "Sveriges demokratisering",
      url: "https://www.youtube.com/watch?v=9Zutz9h12-E&list=PLSHcVfKvOzQMzKwqRJaL0tWHO8Gy-YdnG&index=12&pp=iAQB",
      channel: "URPLAY",
    },
    {
      title: "Franska revolutionen",
      url: "https://www.youtube.com/watch?v=eZW7YzlN0QY&list=PLSHcVfKvOzQMzKwqRJaL0tWHO8Gy-YdnG&index=11&pp=iAQB",
      channel: "URPLAY",
    },
  ],
  litteratur: [
    {
      title: "Karin Boye förklarad",
      url: "https://www.youtube.com/watch?v=y_8tcbe8bEs&list=PLSHcVfKvOzQPSV_NjeSIZPDi3EKe2Xa3y&index=6&pp=iAQB",
      channel: "URPLAY",
    },
    {
      title: "Edith Södergran förklarad",
      url: "https://www.youtube.com/watch?v=4bfMMDEVuWg&list=PLSHcVfKvOzQPSV_NjeSIZPDi3EKe2Xa3y&index=8&pp=iAQB",
      channel: "URPLAY",
    },
    {
      title: "Iliaden förklarad",
      url: "https://www.youtube.com/watch?v=EZ4MnZkchm4&list=PLSHcVfKvOzQPSV_NjeSIZPDi3EKe2Xa3y&index=16&pp=iAQB",
      channel: "URPLAY",
    },

    {
      title: "Don Quijote",
      url: "https://www.youtube.com/watch?v=xmHij5uoeoo&list=PLSHcVfKvOzQPSV_NjeSIZPDi3EKe2Xa3y&index=18&pp=iAQB",
      channel: "URPLAY",
    },
    {
      title: "Den gudomliga  komedin",
      url: "https://www.youtube.com/watch?v=sukWQYkAySw&list=PLSHcVfKvOzQPSV_NjeSIZPDi3EKe2Xa3y&index=17&pp=iAQB",
      channel: "URPLAY",
    },
    {
      title: "Robinson Crusoe",
      url: "https://www.youtube.com/watch?v=G0RHv9CD9SY&list=PLSHcVfKvOzQPSV_NjeSIZPDi3EKe2Xa3y&index=20&pp=iAQB",
      channel: "URPLAY",
    },
  ],

  naturkunskap: [
    {
      title: "Protein förklarad",
      url: "https://www.youtube.com/watch?v=iMh59rrRq_8",
    },
    {
      title: "Genteknik förklarad",
      url: "https://www.youtube.com/watch?v=Ktc9_Bu0SGs",
    },
    {
      title: "Celldelning förklarad",
      url: "https://www.youtube.com/watch?v=ReI0nXyZInE",
    },

    {
      title: "Ozonlagret",
      url: "https://www.youtube.com/watch?v=bsJ_vvDHV5o",
    },
    {
      title: "Miljöfarliga metaller",
      url: "https://www.youtube.com/watch?v=GXLCVZ7pDzY",
    },
    {
      title: "Skogens ekologi",
      url: "https://www.youtube.com/watch?v=DPWvAYX53rw",
    },
  ],
};

export const subjectVideosForYouTube = {
  biologi: [
    {
      title: "Vad är liv?",
      url: "https://www.youtube.com/watch?v=tZE_fQFK8EY&list=PL8dPuuaLjXtPW_ofbxdHNciuLoTRLPMgB&index=2&pp=iAQB",
      channel: "CRASHCOURSE",
    },
    {
      title: "Den vetenskapliga metoden",
      url: "https://www.youtube.com/watch?v=xOLcZMw0hd4&list=PL8dPuuaLjXtPW_ofbxdHNciuLoTRLPMgB&index=3&pp=iAQB",
      channel: "CRASHCOURSE",
    },
    {
      title: "Det naturliga urvalet",
      url: "https://www.youtube.com/watch?v=i-VeKZeyHZs&list=PL8dPuuaLjXtPW_ofbxdHNciuLoTRLPMgB&index=14&pp=iAQB",
      channel: "CRASHCOURSE",
    },
  ],

  klimat: [
    {
      title: "Vad innebär klimatförändring?",
      url: "https://www.youtube.com/watch?v=9PFhrpyWV-w&list=PL8dPuuaLjXtMx8ZIQV9NduU_HFjDwykuj&index=2&pp=iAQB",
      channel: "CRASHCOURSE",
    },

    {
      title: "Förnybar energi",
      url: "https://www.youtube.com/watch?v=rDkaZWirNME&list=PL8dPuuaLjXtMx8ZIQV9NduU_HFjDwykuj&index=5&pp=iAQB",
      channel: "CRASHCOURSE",
    },

    {
      title: "Klimatförändringens kostnad",
      url: "https://www.youtube.com/watch?v=ML70W4O6F4E&list=PL8dPuuaLjXtMx8ZIQV9NduU_HFjDwykuj&index=12&pp=iAQB",
      channel: "CRASHCOURSE",
    },
  ],

  afroamerikanskhistoria: [
    {
      title: "Transatlantiska slavhandeln",
      url: "https://www.youtube.com/watch?v=S72vvfBTQws&list=PL8dPuuaLjXtNYJO8JWpXO2JP0ezgxsrJJ&index=2&pp=iAQB",
      channel: "CRASHCOURSE",
    },
    {
      title: "Om Elizabeth Key",
      url: "https://www.youtube.com/watch?v=hJUknOKAv1M&list=PL8dPuuaLjXtNYJO8JWpXO2JP0ezgxsrJJ&index=4&pp=iAQB",
      channel: "CRASHCOURSE",
    },
    {
      title: "Om Phillis Wheatley",
      url: "https://www.youtube.com/watch?v=a3l9Pmza7Gs&list=PL8dPuuaLjXtNYJO8JWpXO2JP0ezgxsrJJ&index=8&pp=iAQB",
      channel: "CRASHCOURSE",
    },
    {
      title: "Kvinnorna under slaveriet",
      url: "https://www.youtube.com/watch?v=eAe7ETfQ_aA&list=PL8dPuuaLjXtNYJO8JWpXO2JP0ezgxsrJJ&index=12&pp=iAQB",
      channel: "CRASHCOURSE",
    },
    {
      title: "Bomullsindustrin",
      url: "https://www.youtube.com/watch?v=83eJfEFFZ74&list=PL8dPuuaLjXtNYJO8JWpXO2JP0ezgxsrJJ&index=14&pp=iAQB",
      channel: "CRASHCOURSE",
    },
    {
      title: "Om Zora Neale Hurston",
      url: "https://www.youtube.com/watch?v=72ABMa_PuHU&list=PL8dPuuaLjXtNYJO8JWpXO2JP0ezgxsrJJ&index=31&pp=iAQB",
      channel: "CRASHCOURSE",
    },
  ],

  filosofi: [
    {
      title: "Sokrates",
      url: "https://www.youtube.com/watch?v=yneFwkz0rrw",
      channel: "SCHOOLOFLIFE",
    },
    {
      title: "Platon",
      url: "https://www.youtube.com/watch?v=b1ZvtYIajBM",
      channel: "SCHOOLOFLIFE",
    },
    {
      title: "Aristoteles",
      url: "https://www.youtube.com/watch?v=WZ-0wRv-V5o",
      channel: "SCHOOLOFLIFE",
    },
  ],
  konst: [
    { title: "Mona Lisa", url: "https://www.youtube.com/watch?v=eQhUW9O1Wn8" },
  ],

  sociologi: [
    {
      title: "Alexis de Tocqueville",
      url: "https://www.youtube.com/watch?v=Rzr3AOtFA8o&list=PLwxNMb28XmpcoeCDO0VnGUavcLUFiNcAI&index=1&pp=iAQB",
      channel: "SCHOOLOFLIFE",
    },

    {
      title: "Auguste Comte",
      url: "https://www.youtube.com/watch?v=OhVamhT4Q3s&list=PLwxNMb28XmpcoeCDO0VnGUavcLUFiNcAI&index=2&pp=iAQB",
      channel: "SCHOOLOFLIFE",
    },
    {
      title: "Émile Durkheim",
      url: "https://www.youtube.com/watch?v=z9W0GQvONKc&list=PLwxNMb28XmpcoeCDO0VnGUavcLUFiNcAI&index=3&pp=iAQB",
      channel: "SCHOOLOFLIFE",
    },
    {
      title: "Max Weber",
      url: "https://www.youtube.com/watch?v=ICppFQ6Tabw&list=PLwxNMb28XmpcoeCDO0VnGUavcLUFiNcAI&index=4&pp=iAQB",
      channel: "SCHOOLOFLIFE",
    },
    {
      title: "Theodor Adorno",
      url: "https://www.youtube.com/watch?v=4YGnPgtWhsw&list=PLwxNMb28XmpcoeCDO0VnGUavcLUFiNcAI&index=5&pp=iAQB",
      channel: "SCHOOLOFLIFE",
    },
  ],

  politisk_teori: [
    {
      title: "John Maynard Keynes",
      url: "https://www.youtube.com/watch?v=qtAeINU3FKM&list=PLwxNMb28XmpeuwUhM0OT338_T5XTtJJok&index=1&pp=iAQB",
      channel: "SCHOOLOFLIFE",
    },
    {
      title: "Friedrich Hayek",
      url: "https://www.youtube.com/watch?v=SHsCkinrCPE&list=PLwxNMb28XmpeuwUhM0OT338_T5XTtJJok&index=3&pp=iAQB",
      channel: "SCHOOLOFLIFE",
    },
    {
      title: "John Locke",
      url: "https://www.youtube.com/watch?v=bZiWZJgJT7I&list=PLwxNMb28XmpeuwUhM0OT338_T5XTtJJok&index=4&pp=iAQB",
      channel: "SCHOOLOFLIFE",
    },
    {
      title: "Jean-Jacques Rousseau",
      url: "https://www.youtube.com/watch?v=81KfDXTTtXE&list=PLwxNMb28XmpeuwUhM0OT338_T5XTtJJok&index=5&pp=iAQB",
      channel: "SCHOOLOFLIFE",
    },
    {
      title: "Thomas Hobbes",
      url: "https://www.youtube.com/watch?v=9i4jb5XBX5s&list=PLwxNMb28XmpeuwUhM0OT338_T5XTtJJok&index=6&pp=iAQB",
      channel: "SCHOOLOFLIFE",
    },
    {
      title: "Niccolò Machiavelli",
      url: "https://www.youtube.com/watch?v=AOXl0Ll_t9s&list=PLwxNMb28XmpeuwUhM0OT338_T5XTtJJok&index=7&pp=iAQB",
      channel: "SCHOOLOFLIFE",
    },
  ],

  litteratur: [
    {
      title: "Virginia Woolf",
      url: "https://www.youtube.com/watch?v=d1W7wqXD_b0",
      channel: "SCHOOLOFLIFE",
    },
    {
      title: "Jane Austen",
      url: "https://www.youtube.com/watch?v=LIYiThAyY8s&pp=ygULamFuZSBhdXN0ZW4%3D",
      channel: "SCHOOLOFLIFE",
    },
    {
      title: "Voltaire",
      url: "https://www.youtube.com/watch?v=LAzKGkTIKpg&list=PLwxNMb28Xmpfv2COuuJaKzy6E2n8nSMdi&index=1&pp=iAQB",
      channel: "SCHOOLOFLIFE",
    },
    {
      title: "Gustave Flaubert",
      url: "https://www.youtube.com/watch?v=XK8lZO39T-0&list=PLwxNMb28Xmpfv2COuuJaKzy6E2n8nSMdi&index=6&pp=iAQB",
      channel: "SCHOOLOFLIFE",
    },
    {
      title: "Leo Tolstoj",
      url: "https://www.youtube.com/watch?v=Lr6DYLBkyG0&list=PLwxNMb28Xmpfv2COuuJaKzy6E2n8nSMdi&index=8&pp=iAQB",
      channel: "SCHOOLOFLIFE",
    },
    {
      title: "Marcel Proust",
      url: "https://www.youtube.com/watch?v=9mLdo4uMJUU&list=PLwxNMb28Xmpfv2COuuJaKzy6E2n8nSMdi&index=14&pp=iAQB",
      channel: "SCHOOLOFLIFE",
    },

    {
      title: "Franz Kafka",
      url: "https://www.youtube.com/watch?v=g4LyzhkDNBM&list=PLwxNMb28Xmpfv2COuuJaKzy6E2n8nSMdi&index=17&pp=iAQB",
      channel: "SCHOOLOFLIFE",
    },
    {
      title: "James Joyce",
      url: "https://www.youtube.com/watch?v=1SuHkY2wAQA&list=PLwxNMb28Xmpfv2COuuJaKzy6E2n8nSMdi&index=13&pp=iAQB",
      channel: "SCHOOLOFLIFE",
    },
    {
      title: "Charles Dickens",
      url: "https://www.youtube.com/watch?v=N9dB9BZWDBU&list=PLwxNMb28Xmpfv2COuuJaKzy6E2n8nSMdi&index=7&pp=iAQB",
      channel: "SCHOOLOFLIFE",
    },
  ],
  historia: [
    {
      title: "Forntida Egypten",
      url: "https://www.youtube.com/watch?v=hO1tzmi1V5g&pp=ygUPY2xlb3BhdHJhIGZhY3Rz",
      channel: "NATIONALGEOGRAPHIC",
    },

    {
      title: "Antikens Rom",
      url: "https://www.youtube.com/watch?v=GXoEpNjgKzg",
      channel: "NATIONALGEOGRAPHIC",
    },
    {
      title: "Om Katherine Johnson",
      url: "https://www.youtube.com/watch?v=E4j_LpKzcZQ",
      channel: "NATIONALGEOGRAPHIC",
    },

    {
      title: "Historien om Gaza",
      url: "https://www.youtube.com/watch?v=zdq3NVtT6Nc&pp=ygULY25uIGhpc3Rvcnk%3D",
      channel: "CNN",
    },

    {
      title: "Om Jackie Kennedy",
      url: "https://www.youtube.com/watch?v=ei8XBm3-9lY",
      channel: "CAPTIVATINGHISTORY",
    },
    {
      title: "Vincent Van Gogh",
      url: "https://www.youtube.com/watch?v=7oPPVl1YMP8",
      channel: "CAPTIVATINGHISTORY",
    },
    {
      title: "Om Fascism",
      url: "https://www.youtube.com/watch?v=t7lUdwyq-KU",
      channel: "CAPTIVATINGHISTORY",
    },
  ],
};

// Available speakers data
export const availableSpeakers = [
  {
    id: "ash",
    name: "Ash",
    avatar: "https://sportkuriren.se/wp-content/uploads/ash.png",
  },
  {
    id: "nova",
    name: "Nova",
    avatar: "https://sportkuriren.se/wp-content/uploads/nova.png",
  },
  {
    id: "onyx",
    name: "Onyx",
    avatar: "https://sportkuriren.se/wp-content/uploads/onyx.png",
  },
  // {
  //   id: "shimmer",
  //   name: "Shimmer",
  //   avatar: "https://sportkuriren.se/wp-content/uploads/shimmer.png",
  // },
  {
    id: "echo",
    name: "Echo",
    avatar: "https://sportkuriren.se/wp-content/uploads/echo.png",
  },
  {
    id: "alloy",
    name: "Alloy",
    avatar: "https://sportkuriren.se/wp-content/uploads/alloy.png",
  },
  {
    id: "sage",
    name: "Sage",
    avatar: "https://sportkuriren.se/wp-content/uploads/sage.png",
  },
  {
    id: "coral",
    name: "Coral",
    avatar: "https://sportkuriren.se/wp-content/uploads/coral.png",
  },
  {
    id: "ballad",
    name: "Ballad",
    avatar: "https://sportkuriren.se/wp-content/uploads/ballad.png",
  },
];

// Function to convert Swedish language names to English
export const mapLanguageToEnglish = (swedishLanguage) => {
  const languageMap = {
    // Swedish to English language mapping
    amhariska: "amharic",
    arabiska: "arabic",
    albanska: "albanian",
    assyriska: "assyrian",
    bengali: "bengali",
    bosniska: "bosnian",
    "brasiliansk-portugisiska": "brazilian portuguese",
    bulgariska: "bulgarian",
    dari: "dari",
    danska: "danish",
    engelska: "english",
    estniska: "estonian",
    farsi: "farsi",
    finska: "finnish",
    franska: "french",
    grekiska: "greek",
    hebreiska: "hebrew",
    hindi: "hindi",
    indonesiska: "indonesian",
    isländska: "icelandic",
    italienska: "italian",
    japanska: "japanese",
    kannada: "kannada",
    kinesiska: "chinese",
    koreanska: "korean",
    kroatiska: "croatian",
    tigrinja: "tigrinya",
    kurdiska: "kurdish",
    lettiska: "latvian",
    litauiska: "lithuanian",
    makedonska: "macedonian",
    nederländska: "dutch",
    norska: "norwegian",
    polska: "polish",
    pashtu: "pashto",
    persiska: "persian",
    portugisiska: "portuguese",
    punjabi: "punjabi",
    rumänska: "romanian",
    ryska: "russian",
    serbiska: "serbian",
    slovakiska: "slovak",
    slovenska: "slovenian",
    somali: "somali",
    sorani: "sorani",
    spanska: "spanish",
    svenska: "swedish",
    swahili: "swahili",
    tagalog: "tagalog",
    tamil: "tamil",
    telugu: "telugu",
    thai: "thai",
    tjeckiska: "czech",
    turkiska: "turkish",
    tyska: "german",
    ukrainska: "ukrainian",
    ungerska: "hungarian",
    uiguriska: "uyghur",
    urdu: "urdu",
    vietnamesiska: "vietnamese",
    wolof: "wolof",
    malayalam: "malayalam",
    marathi: "marathi",
    gujarati: "gujarati",
    khmer: "khmer",
    havasa: "hausa",
    yoruba: "yoruba",
    igbo: "igbo",
    burmesiska: "burmese",
    armeniska: "armenian",
    azerbajdzjanska: "azerbaijani",
    berber: "berber",
    "egyptisk-arabiska": "egyptian arabic",
    georgiska: "georgian",
    kabyliska: "kabyle",
    "maghrebi-arabiska": "maghrebi arabic",
    maltesiska: "maltese",
    "modern-standardarabiska": "modern standard arabic",
    tachelhit: "tachelhit",
    "thai-lao": "thai-lao",
    nepali: "nepali",
    sinhala: "sinhala",
    malagasy: "malagasy",
    zulu: "zulu",
    xhosa: "xhosa",
    afrikaans: "afrikaans",
    mongoliska: "mongolian",
    kazakiska: "kazakh",
    uzbekiska: "uzbek",
    tibetanska: "tibetan",
    karen: "karen",
  };

  return languageMap[swedishLanguage] || swedishLanguage;
};

export default mapLanguageToEnglish;

export const BackButton = ({
  currentStep,
  setCurrentStep,
  onClick,
  show = true,
  text = "Tillbaka",
  sx = {},
}) => {
  if (!show) return null;
  const location = useLocation();
  const theme = useTheme();
  const hasVParam =
    location.search.includes("?v=t") || location.search.includes("&v=t");
  const navigate = useNavigate();

  const handleClick = (e) => {
    const url = location.pathname;
    const lessonIds = [
      "Wjf2cWXQir",
      "7lxmZwqc8l",
      "N46W8qE4wP",
      "sfzkAeuJ22",
      "A6TAZCV7fU",
      "7XOuiEc3kD",
      "ug3txMBUZY",
      "8RrTHhJz1E",
      "I7qKiME1td",
      "29hmsRNaZ6",
      "94u26m0hqB",
      "jyUXRz9SHp",
      "rDSrOCAa9p",
      "1ec35VP3ju",
      "9J4GY1ElLo",
      "79n31gpSHk",
      "2GKNnMWwW0",
      "y6zglZOLT1",
      "8PEm3ZbYmW",
      "byxjKAln0Q",
      "AVGAYBUbn1",
      "rc8jQ0hkSX",
      "zU5Vbfitpa",
      "1mRLhokexN",
      "GTwb6hw4is",
      "n1p0y8r2ge",
      "vTG2ix77SV",
      "1WsWSwO1CZ",
      "4zDhrMTxcM",
      "PheP22vOZN",
      "9sNMqcKh0S",
      "YeSn4Pc1yp",
      "oU7o7CQBnC",
    ];
    if (lessonIds.some((id) => url.includes(id))) {
      navigate("/app/lektioner");
    } else if (onClick) {
      onClick(e);
    }
  };

  const handleFixClick = () => {
    const url = location.pathname;
    const urlWithoutLastPart = url.substring(0, url.lastIndexOf("/"));
    setCurrentStep(1);
    navigate(urlWithoutLastPart + location.search);
  };

  const buttonStyles = {
    position: "absolute",
    top: { xs: "16px", md: "18px" },
    paddingTop: { xs: "6px", md: 1 },
    paddingBottom: { xs: "6px", md: 1 },
    fontSize: { xs: "0.9rem", md: "1rem" },
    bgcolor:
      theme.palette.mode === "dark"
        ? "rgba(255,255,255,0.1)"
        : "rgba(0,0,0,0.05)",
    "&:hover": {
      bgcolor:
        theme.palette.mode === "dark"
          ? "rgba(255,255,255,0.2)"
          : "rgba(0,0,0,0.1)",
    },
  };

  return (
    <Box
      sx={{
        display: hasVParam ? "none" : "flex",
        justifyContent: "flex-start",
        mt: 2,
        mb: 2,
      }}
    >
      <IconButton
        variant="purp"
        onClick={handleClick}
        sx={{
          ...buttonStyles,
          left: { xs: "60px", md: "0px" },
          ...sx,
        }}
      >
        <ArrowBackIcon />
      </IconButton>

      {currentStep === 9 && (
        <IconButton
          variant="purp"
          onClick={handleFixClick}
          sx={{
            ...buttonStyles,
            left: { xs: "120px", md: "60px" },
            ...sx,
          }}
        >
          <AutoFixHighIcon />
        </IconButton>
      )}
    </Box>
  );
};

export const hasThemeContent = (lessonTheme, refs) => {
  if (!lessonTheme) return false;

  // Simple content check based on theme type
  switch (lessonTheme) {
    case "youtube":
      return !!refs.transcriptRef.current?.trim();
    case "customTheme":
      return !!refs.customTheme?.trim();
    case "predefined":
      return !!refs.predefinedTheme?.trim();
    case "fileUpload":
      return !!refs.uploadedFileRef.current?.trim();
    case "wikipedia":
      return !!refs.wikipediaContentRef.current?.trim();
    case "randomizer":
      return !!refs.randomizedContentRef.current?.trim();
    case "book":
      return !!refs.bookContentRef.current?.trim();
    case "url":
      return !!refs.urlContentRef.current?.trim();
    case "vision":
      return !!refs.analysisContentRef.current?.trim();
    default:
      return !!refs.coursePlanContentRef.current?.trim();
  }
};

export const handlePrint = (essayResults) => {
  const printWindow = window.open("", "_blank");
  const contentToPrint = essayResults;

  printWindow.document.write(`
    <html>
      <head>
        <title>Bedömning av text från Studera.ai</title>
        <style>
          @page {
            size: A4;
            margin: 0cm 0cm 2cm 0cm;
            marks: none;
          }
          html {
            padding: 0cm 2cm 2cm 2cm !important;
            margin: 0 !important;
            margin-top: 2cm !important;
          }
          body { 
            margin: 0 !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            font-family: Arial, sans-serif;
            line-height: 1.6;
            color: #333;
            padding: 20px;
          }


          h1 { color: #2c3e50; }
          .ql-editor { padding: 0; }
          .ql-editor * { font-family: Arial, sans-serif; }
        </style>
      </head>
      <body>
        <h1>Bedömningsresultat</h1>
        <div class="ql-editor">
          ${contentToPrint}
        </div>
      </body>
    </html>
  `);
  printWindow.document.close();
  printWindow.print();
};

export const InstructionItem = ({
  text,
  simple = false,
  marginBottom = 3,
  color,
  fontWeight = 500,
}) => {
  // Split the text at the first colon only if `simple` is false
  const [title, ...rest] = simple ? [text, ""] : text.split(":");
  const content = rest.join(":"); // Rejoin the rest in case there are more colons

  const theme = useTheme();
  const styles = getStyles(theme);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        mb: marginBottom,
      }}
    >
      <Box
        sx={{
          minWidth: 24,
          minHeight: 24,
          borderRadius: "50%",
          backgroundColor:
            theme.palette.mode === "dark"
              ? "rgba(255, 255, 255, 0.1)"
              : "#6d31ed1c",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mr: 2,
          flexShrink: 0,
          mt: 0.5,
        }}
      >
        <CheckIcon sx={{ fontSize: 16, color: "#7B68EE" }} />
      </Box>
      <Typography
        sx={{
          ...styles.softerText,
          fontSize: "1rem",
          lineHeight: 1.8,
          fontWeight: fontWeight,
          color: color,
        }}
      >
        {simple ? (
          <Box component="span" sx={{ fontWeight: fontWeight }}>
            {text}
          </Box>
        ) : (
          <>
            <Box component="span" sx={{ fontWeight: 700 }}>
              {title}
            </Box>
            :{content}
          </>
        )}
      </Typography>
    </Box>
  );
};

export const DialogTransition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
//Hej

export const lessonVideoMapping = (lessonType) => {
  const baseUrl = "https://sportkuriren.se/wp-content/uploads";

  const mappings = {
    // Basic Reading Comprehension and variants
    "BasicReadingCompLesson.js": `${baseUrl}/basic-reading-comp.mp4`,
    "BasicReadingCompLessonVariantFactText.js": `${baseUrl}/fact-text.mp4`,
    "BasicReadingCompLessonVariantInstructingText.js": `${baseUrl}/instructing-text.mp4`,
    "BasicReadingCompLessonVariantExplainingText.js": `${baseUrl}/explaining-text.mp4`,
    "BasicReadingCompLessonVariantChronicle.js": `${baseUrl}/chronicle.mp4`,
    "BasicReadingCompLessonVariantReview.js": `${baseUrl}/review.mp4`,
    "BasicReadingCompLessonVariantArgumentativeText.js": `${baseUrl}/argumentative-text.mp4`,
    "BasicReadingCompLessonVariantDescriptiveText.js": `${baseUrl}/descriptive-text.mp4`,

    // Timeline and Interactive Lessons
    "TimelineLesson.js": `${baseUrl}/timeline.mp4`,
    "EscapeRoomLesson.js": `${baseUrl}/escape-room.mp4`,
    "TimelineBuilderLesson.js": `${baseUrl}/timeline-builder.mp4`,
    "RolePlayLesson.js": `${baseUrl}/role-play.mp4`,

    // Writing and Literature
    "DiaryLesson.js": `${baseUrl}/diary.mp4`,
    "LessonPlanRevamp.js": `${baseUrl}/gradino3.mp4`,
    "LiteratureSchool.js": `${baseUrl}/literature-school.mp4`,
    "LettersLesson.js": `${baseUrl}/letters.mp4`,

    // Analysis and Creative Lessons
    "VisionAnalysis.js": `${baseUrl}/vision-analysis.mp4`,
    "HistoricPersonLesson.js": `${baseUrl}/historic-person.mp4`,
    "DetectiveReadingCompLesson.js": `${baseUrl}/detective-reading.mp4`,
    "CreativeReadingCompLesson.js": `${baseUrl}/creative-reading.mp4`,
    "ComparativeReadingCompLesson.js": `${baseUrl}/comparative-reading.mp4`,

    // Games and Interactive Features
    "ClueGeneratorLesson.js": `${baseUrl}/clue-generator.mp4`,
    "TermsGridLesson.js": `${baseUrl}/terms-grid.mp4`,
    "WeeklyWordsLesson.js": `${baseUrl}/weekly-words.mp4`,
    "TongueTwistersLesson.js": `${baseUrl}/tongue-twisters.mp4`,

    // Grammar and Language
    "GrammarLesson.js": `${baseUrl}/grammar.mp4`,
    "IdiomsLesson.js": `${baseUrl}/idioms.mp4`,
    "NewsLesson.js": `${baseUrl}/news.mp4`,
    "MysticImageLesson.js": `${baseUrl}/mystic-image.mp4`,
    "FindWordsLesson.js": `${baseUrl}/find-words.mp4`,
    "LetterBoxLesson.js": `${baseUrl}/letter-box.mp4`,

    // Writing and Narrative
    "WritingLesson.js": `${baseUrl}/writing.mp4`,
    "SentenceFinisherLesson.js": `${baseUrl}/sentence-finisher.mp4`,
    "NarrativeLesson.js": `${baseUrl}/narrative.mp4`,
    "GrejOfTheDay.js": `${baseUrl}/grej-of-the-day.mp4`,
    "WordCompLesson.js": `${baseUrl}/word-comp.mp4`,

    // Conversation and Communication
    "ConversationLesson.js": `${baseUrl}/conversation.mp4`,
    "ConversationLessonVariantInterview.js": `${baseUrl}/interview.mp4`,
    "ArgumentationLesson.js": `${baseUrl}/argumentation.mp4`,

    // Presentation Tools
    "JeopardyLesson.js": `${baseUrl}/jeopardy.mp4`,
    "PowerPointGenerator.js": `${baseUrl}/powerpoint-generator.mp4`,
    "MindMapLesson.js": `${baseUrl}/mind-map.mp4`,
  };

  // Return the video URL if mapping exists, otherwise return a default video URL
  return mappings[lessonType] || `${baseUrl}/default-lesson.mp4`;
};

export const lessonMapping = (lessonType) => {
  const mappings = {
    "BasicReadingCompLesson.js": "Läsförståelse",
    // Varianter:
    "BasicReadingCompLessonVariantFactText.js": "Faktatext",
    "BasicReadingCompLessonVariantInstructingText.js": "Instruerande text",
    "BasicReadingCompLessonVariantExplainingText.js": "Förklarande text",
    "BasicReadingCompLessonVariantChronicle.js": "Krönika",
    "BasicReadingCompLessonVariantReview.js": "Recension",
    "BasicReadingCompLessonVariantArgumentativeText.js": "Argumenterande text",
    "BasicReadingCompLessonVariantDescriptiveText.js": "Beskrivande text",

    "ColoringLesson.js": "Målarbilder",

    "TimelineLesson.js": "Tidslinjer",
    "EscapeRoomLesson.js": "Escape Room",
    "TimelineBuilderLesson.js": "Bygg tidslinjer",
    "RolePlayLesson.js": "Rollkort",
    "DiaryLesson.js": "Fiktiva dagböcker",
    "LessonPlanRevamp.js": "Lektionsplan",
    "LiteratureSchool.js": "Litteraturskolan",

    "LettersLesson.js": "Fiktiva brev",
    "VisionAnalysis.js": "Bildanalys",

    "HistoricPersonLesson.js": "Historisk person",

    "DetectiveReadingCompLesson.js": "Läsdetektiven",
    "CreativeReadingCompLesson.js": "Kreativ läsförståelse",
    "ComparativeReadingCompLesson.js": "Jämförande läsförståelse",

    "ClueGeneratorLesson.js": "På spåret",
    "TermsGridLesson.js": "Glosor i lådor",
    "WeeklyWordsLesson.js": "Veckans ord",
    "TongueTwistersLesson.js": "Tungvrickare",
    "GrammarLesson.js": "Grammatiklektion",
    "IdiomsLesson.js": "Idiomatiska uttr.",
    "NewsLesson.js": "Fiktiva nyhetsredaktionen",
    "MysticImageLesson.js": "Mystiska bilden",
    "FindWordsLesson.js": "Hitta orden",
    "LetterBoxLesson.js": "Bilda ordet",

    "WritingLesson.js": "Skrivlektion",
    "SentenceFinisherLesson.js": "Forts. berättelsen",
    "NarrativeLesson.js": "Berättande text",
    "GrejOfTheDay.js": "Grej of the day",
    "WordCompLesson.js": "Ordförståelse",
    "ConversationLesson.js": "Konversation",
    // Varianter:
    "ConversationLessonVariantInterview.js": "Intervju",

    "ArgumentationLesson.js": "Argumentera",
    "JeopardyLesson.js": "Jeopardy",
    "PowerPointGenerator.js": "Generera PowerPoint",

    "MindMapLesson.js": "Tankekartor",

    // Lägg till fler mappings här efter behov
  };

  // Returnera mappningen om den finns, annars returnera original lessonType
  return mappings[lessonType] || lessonType;
};

export const getLessonTypeParam = (lessonType) => {
  const mappings = {
    "BasicReadingCompLesson.js": "default",
    "BasicReadingCompLessonVariantFactText.js": "factText",
    "BasicReadingCompLessonVariantInstructingText.js": "instructingText",
    "BasicReadingCompLessonVariantExplainingText.js": "explainingText",

    "BasicReadingCompLessonVariantArgumentativeText.js": "argumentativeText",
    "BasicReadingCompLessonVariantDescriptiveText.js": "descriptiveText",

    "BasicReadingCompLessonVariantChronicle.js": "chronicle",
    "BasicReadingCompLessonVariantReview.js": "review",

    "ConversationLessonVariantInterview.js": "interview",
    // Add more mappings as needed for other lesson types
  };

  return mappings[lessonType] || "default"; // Return 'default' as fallback
};

// Mapping för URL-paths
export const lessonUrlMapping = (lessonType) => {
  const urlMappings = {
    "BasicReadingCompLesson.js": "lasforstaelse",
    "BasicReadingCompLessonVariantFactText.js": "lasforstaelse",
    "BasicReadingCompLessonVariantInstructingText.js": "lasforstaelse",
    "BasicReadingCompLessonVariantExplainingText.js": "lasforstaelse",
    "BasicReadingCompLessonVariantChronicle.js": "lasforstaelse",
    "BasicReadingCompLessonVariantReview.js": "lasforstaelse",

    "BasicReadingCompLessonVariantArgumentativeText.js": "lasforstaelse",
    "BasicReadingCompLessonVariantDescriptiveText.js": "lasforstaelse",

    "VisionAnalysis.js": "vision",
    "ColoringLesson.js": "malarbilder",
    "TimelineLesson.js": "tidslinjer",
    "MindMapLesson.js": "tankekartor",
    "EscapeRoomLesson.js": "escape-room",
    "TimelineBuilderLesson.js": "bygg-tidslinjer",
    "RolePlayLesson.js": "rollkort",
    "DiaryLesson.js": "fiktiva-dagbocker",
    "LessonPlanRevamp.js": "lektionsplan",
    "LettersLesson.js": "fiktiva-brev",
    "HistoricPersonLesson.js": "historisk-person",
    "LiteratureSchool.js": "litteraturskolan",

    "WordCompLesson.js": "ordforstaelse",
    "ArgumentationLesson.js": "argumentera",
    "NewsLesson.js": "fiktiva-nyhetsredaktionen",
    "PowerPointGenerator.js": "generera-powerpoint",

    "CreativeReadingCompLesson.js": "kreativ-lasforstaelse",
    "ConversationLessonVariantInterview.js": "konversation",
    "ConversationLesson.js": "konversation",

    "DetectiveReadingCompLesson.js": "lasdetektiven",
    "ClueGeneratorLesson.js": "pa-sparet",
    "JeopardyLesson.js": "jeopardy",
    "TermsGridLesson.js": "glosor-i-lador",
    "WeeklyWordsLesson.js": "veckans-ord",
    "TongueTwistersLesson.js": "tungvrickare",
    "GrammarLesson.js": "grammatik",
    "IdiomsLesson.js": "idiom",
    "MysticImageLesson.js": "mystiska-bilden",
    "FindWordsLesson.js": "hitta-orden",
    "LetterBoxLesson.js": "bokstaver",
    "WritingLesson.js": "skrivlektion",
    "SentenceFinisherLesson.js": "fortsatt-berattelsen",
    "NarrativeLesson.js": "berattande-text",
    "GrejOfTheDay.js": "grej-of-the-day",
  };
  return urlMappings[lessonType] || lessonType.toLowerCase().replace(".js", "");
};

// Reverse mapping för att få lessonType från URL
export const getlessonTypeFromUrl = (urlPath) => {
  const reverseUrlMappings = Object.entries(lessonUrlMapping()).reduce(
    (acc, [key, value]) => {
      acc[value] = key;
      return acc;
    },
    {},
  );
  return reverseUrlMappings[urlPath] || urlPath;
};

export const extractJsonFromString = (str) => {
  try {
    // First attempt: Try parsing the string directly
    try {
      return JSON.parse(str);
    } catch (e) {
      // If direct parsing fails, try to extract JSON
    }

    // Look for JSON between triple backticks
    const jsonMatch = str.match(/```(?:json)?\s*({[\s\S]*?})\s*```/);
    if (jsonMatch) {
      return JSON.parse(jsonMatch[1]);
    }

    // If no triple backticks, look for what appears to be a JSON object
    const objectMatch = str.match(/({[\s\S]*})/);
    if (objectMatch) {
      return JSON.parse(objectMatch[1]);
    }

    // If we reach here, no valid JSON was found
    throw new Error("No valid JSON found in the response");
  } catch (error) {
    console.error("Error parsing JSON:", error);
    throw new Error(`Failed to parse JSON: ${error.message}`);
  }
};

export const handleImageGenerationError = (
  error,
  isMultipleImages = false,
  showSnackbar,
) => {
  if (error.message.includes("safety system")) {
    showSnackbar(
      `Säkerhetssystemet avvisade ${isMultipleImages ? "en eller flera bilder" : "bilden"}. Försök med en annan beskrivning.`,
      "error",
    );
  } else {
    console.error("handleImageGenerationError: ", error);
    showSnackbar(
      `Serverfel: ${isMultipleImages ? "Bilderna" : "Bilden"} kunde inte genereras`,
      "error",
    );
  }
};

export async function getTrackedLessons(userId, lessonType) {
  Logger.log("lessonType in getTrackedLessons: ", lessonType);

  // const adminUsers = [
  //     'Z1dF5PGfjvdBGS9egzACvcSRZiN2',
  //     'x2rjH7JxWxc6GnFgPSTxGxN1bm63',
  //   'Z6BLSMsm38Un5mgW0O6Z3TToHq12',
  // ];

  try {
    const q = query(
      collection(db, "lesson_usage"),

      where("lessonType", "==", lessonType),
      where("hasPrinted", "==", true),
      where("featured", "==", true),
      orderBy("timestamp", "desc"),
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
      timestamp: doc.data().timestamp?.toDate(),
    }));
  } catch (error) {
    console.error("Error getting tracked lessons:", error);
    return [];
  }
}

export async function checkLessonLimit(userId, lessonType = null) {
  // Skip limit for admin users
  const adminUsers = [
    "Z1dF5PGfjvdBGS9egzACvcSRZiN2",
    "x2rjH7JxWxc6GnFgPSTxGxN1bm63",
    "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
  ];
  if (adminUsers.includes(userId)) {
    return true;
  }

  try {
    const userDoc = await getDoc(doc(db, "users", userId));
    const isPremium = userDoc.exists() && userDoc.data().isPremium === true;

    Logger.log("lessonType: ", lessonType);
    // For premium users generating images, check monthly limit instead of daily
    if (isPremium && lessonType === "ImageGenerator.js") {
      const now = new Date();
      const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);

      const imageQuery = query(
        collection(db, "lesson_usage"),
        where("userId", "==", userId),
        where("lessonType", "==", "ImageGenerator.js"),
        where("timestamp", ">=", Timestamp.fromDate(startOfMonth)),
      );

      const querySnapshot = await getDocs(imageQuery);
      const imageCount = querySnapshot.size;

      Logger.log(
        "Monthly image count for premium user",
        userId,
        "is",
        imageCount,
      );

      // dra ner till 2, sätt premium på testus7 och testa så det funkar:

      if (imageCount >= 50) {
        const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);

        const event = new CustomEvent("imageError", {
          detail: {
            type: "IMAGE_LIMIT_ERROR",
            message: "Månatlig gräns för bildgenerering uppnådd.",
            resetTime: nextMonth.getTime(),
          },
        });
        window.dispatchEvent(event);
        return false;
      }

      return true;
    }

    // For premium users with other lessons, or free users with any lessons
    if (isPremium && lessonType !== "ImageGenerator.js") {
      Logger.log("Premium user - no limits for non-image lessons");
      return true; // Premium users bypass the limit check for non-image lessons
    }

    // Calculate timestamp for 24 hours ago (for free users)
    const oneDayAgo = new Date();
    oneDayAgo.setHours(oneDayAgo.getHours() - 24);

    // Query lessons from the last 24 hours
    const lessonQuery = query(
      collection(db, "lesson_usage"),
      where("userId", "==", userId),
      where("timestamp", ">=", Timestamp.fromDate(oneDayAgo)),
    );

    const querySnapshot = await getDocs(lessonQuery);
    const lessonCount = querySnapshot.size;
    Logger.log("lessonCount for ", userId, " is ", lessonCount);

    if (lessonCount >= process.env.REACT_APP_LESSON_GENERATION_LIMIT) {
      const event = new CustomEvent("lessonError", {
        detail: {
          type: "LESSON_LIMIT_ERROR",
          message: "Daglig användning uppnådd.",
          resetTime: Date.now() + 24 * 60 * 60 * 1000,
        },
      });
      window.dispatchEvent(event);
      return false;
    }

    return true;
  } catch (error) {
    console.error("Error checking lesson limit:", error);
    return false;
  }
}

// export async function checkLessonLimit(userId) {
//   // Skip limit for admin users
//   const adminUsers = [
//     "Z1dF5PGfjvdBGS9egzACvcSRZiN2",
//     "x2rjH7JxWxc6GnFgPSTxGxN1bm63",
//     "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
//   ];

//   if (adminUsers.includes(userId)) {
//     return true;
//   }

//   // Calculate timestamp for 24 hours ago
//   const oneDayAgo = new Date();
//   oneDayAgo.setHours(oneDayAgo.getHours() - 24);

//   // Query lessons from the last 24 hours
//   const lessonQuery = query(
//     collection(db, "lesson_usage"),
//     where("userId", "==", userId),
//     where("timestamp", ">=", Timestamp.fromDate(oneDayAgo)),
//   );

//   try {
//     const userDoc = await getDoc(doc(db, "users", userId));
//     if (userDoc.exists() && userDoc.data().isPremium === true) {
//       Logger.log("returns true from here");
//       return true; // Premium users bypass the limit check
//     }

//     const querySnapshot = await getDocs(lessonQuery);
//     const lessonCount = querySnapshot.size;
//     Logger.log("lessonCount for ", userId, " is ", lessonCount);
//     if (lessonCount >= process.env.REACT_APP_LESSON_GENERATION_LIMIT) {
//       const event = new CustomEvent("lessonError", {
//         detail: {
//           type: "LESSON_LIMIT_ERROR",
//           message: "Du har nått din dagliga gräns för lektioner.",
//           resetTime: Date.now() + 24 * 60 * 60 * 1000,
//         },
//       });
//       window.dispatchEvent(event);
//       return false;
//     }

//     return true;
//   } catch (error) {
//     console.error("Error checking lesson limit:", error);
//     return false;
//   }
// }

export async function trackLesson(
  userId,
  lessonType,
  generatedData,
  formData = {},
  hasPrinted = false,
  comment = "",
  lessonName = "",
  coverImage = null,
  tags = null,
  shared = false,
  sharedToUserId = null,
  sharedMessage = null,
) {
  try {
    const withinLimit = await checkLessonLimit(userId, lessonType);
    if (!withinLimit) {
      return false;
    }

    await addDoc(collection(db, "lesson_usage"), {
      userId,
      lessonType,
      timestamp: serverTimestamp(),
      data: generatedData,
      formData,
      hasPrinted: hasPrinted,
      comment: comment,
      lessonName: lessonName,
      coverImage: coverImage,
      tags: tags,
      shared: shared,
      sharedToUserId: sharedToUserId,
      sharedMessage: sharedMessage,
    });
  } catch (error) {
    console.error("Error tracking lesson:", error);
  }
}

export const CustomFormControlLabel2 = ({
  control,
  label,
  checked,
  onChange,
  disabled = false,
  theme,
  borderRadius = "8px",
}) => {
  return React.createElement(FormControlLabel, {
    control: React.cloneElement(control, {
      icon: React.createElement(RadioButtonUnchecked, { sx: { fontSize: 16 } }),
      checkedIcon: React.createElement(CheckCircle, { sx: { fontSize: 16 } }),
      checked: checked,
      onChange: onChange,
      disabled: disabled,
      sx: {
        width: 30,
        height: 30,
        borderRadius: "50%",
        bgcolor: checked ? theme.palette.text.main : "transparent",
        border: "2px solid",
        borderColor: checked
          ? theme.palette.text.main
          : theme.palette.background.paperHover,
        "&:hover": {
          bgcolor: checked
            ? lighten(theme.palette.text.main, 0.1)
            : theme.palette.background.paperHover,
          borderColor: theme.palette.text.main,

          transform: "scale(1.1)",
        },
        "& .MuiSvgIcon-root": {
          color: checked
            ? theme.palette.text.white
            : theme.palette.text.primary,
          transition: "all 0.2s ease-out",
        },
        transition: "all 0.2s ease-out",
        "&.Mui-disabled": {
          opacity: 0.5,
        },
      },
    }),
    label: React.createElement(Typography, {
      sx: {
        ml: 1,
        fontWeight: "600 !important",
        fontSize: "1rem",
        color: checked ? theme.palette.text.marked : theme.palette.text.primary,
      },
      children: label,
    }),
    sx: {
      m: 0.25,
      py: 0.5,
      px: 1,
      borderRadius: borderRadius,
      border: "2px solid",
      borderColor: checked ? theme.palette.text.main : "transparent",
      bgcolor: checked ? theme.palette.background.paperHover : "transparent",
      "&:hover": {
        bgcolor: checked
          ? theme.palette.background.paperHover
          : theme.palette.background.paperHover,
        borderColor: checked ? theme.palette.text.main : "transparent",
        border: (theme) => `2px solid ${theme.palette.text.main}`,
      },
      transition: "all 0.2s ease-out",
      "&.Mui-disabled": {
        opacity: 0.5,
      },
    },
  });
};

export const CustomFormControlLabel = ({
  control,
  label,
  checked,
  onChange,
  disabled = false,
  theme,
  borderRadius = "24px", // New prop with default value
}) => {
  const isDarkMode = theme?.palette.mode === "dark";
  return React.createElement(FormControlLabel, {
    control: React.cloneElement(control, {
      icon: React.createElement(RadioButtonUnchecked, { sx: { fontSize: 16 } }),
      checkedIcon: React.createElement(CheckCircle, { sx: { fontSize: 16 } }),
      checked: checked,
      onChange: onChange,
      disabled: disabled,
      sx: {
        width: 30,
        height: 30,
        borderRadius: "50%",
        bgcolor: checked ? "#8B5CF6" : "transparent",
        border: "2px solid",
        borderColor: checked ? "#8B5CF6" : isDarkMode ? "#475569" : "#E2E8F0",
        "&:hover": {
          bgcolor: checked ? "#8B5CF6" : isDarkMode ? "#1E293B" : "#F8FAFC",
          borderColor: "#8B5CF6",
          transform: "scale(1.1)",
        },
        "& .MuiSvgIcon-root": {
          color: checked ? "white" : isDarkMode ? "#94A3B8" : "#94A3B8",
          transition: "all 0.2s ease-out",
        },
        transition: "all 0.2s ease-out",
        "&.Mui-disabled": {
          opacity: 0.5,
        },
      },
    }),
    label: React.createElement(Typography, {
      sx: {
        ml: 1,
        fontWeight: 500,
        fontSize: "1rem",
        color: checked ? "#6D28D9" : isDarkMode ? "#94A3B8" : "#64748B",
      },
      children: label,
    }),
    sx: {
      m: 0.25,
      py: 0.5,
      px: 1,
      borderRadius: borderRadius, // Using the new prop
      border: "2px solid",
      borderColor: checked ? "#8B5CF6" : "transparent",
      bgcolor: checked ? (isDarkMode ? "#1E293B" : "#F3E8FF") : "transparent",
      "&:hover": {
        bgcolor: checked
          ? isDarkMode
            ? "#1E293B"
            : "#F3E8FF"
          : isDarkMode
            ? "#1E293B"
            : "#F3E8FF",
        borderColor: checked ? "#8B5CF6" : "transparent",
      },
      transition: "all 0.2s ease-out",
      "&.Mui-disabled": {
        opacity: 0.5,
      },
    },
  });
};

async function checkImageLimit(userId) {
  // Moonshine: GÖr inte så många db anrop. skikca in user som prop och kolla user.payingsubscriber
  // const userRef1 = doc(db, 'users', userId);
  // const userDoc1 = await getDoc(userRef1);

  // if (!userDoc1.exists()) {
  //   throw new Error('User not found (checkImageLimit)');
  // }

  // const userData1 = userDoc1.data();
  // if (userData1.payingSubscriber === true) {
  //   return true;
  // }

  // Lista över admin användar-IDs som ska skippa limiten
  const adminUsers = [
    "Z1dF5PGfjvdBGS9egzACvcSRZiN2",
    "x2rjH7JxWxc6GnFgPSTxGxN1bm63",
    "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
  ];

  // Kolla om användaren är admin
  if (adminUsers.includes(userId)) {
    return true;
  }

  const userRef = doc(db, "image_usage", userId);
  const userDoc = await getDoc(userRef);

  if (!userDoc.exists()) {
    await setDoc(userRef, {
      count: 1,
      limitHitTime: null,
    });
    return true;
  }

  const data = userDoc.data();

  // If they previously hit the limit, check if 24 hours have passed
  if (data.limitHitTime) {
    const limitTime = data.limitHitTime.toDate();
    const now = new Date();
    const hoursPassed = (now - limitTime) / (1000 * 60 * 60);

    if (hoursPassed < 24) {
      Logger.log("Tot bilder idag: ", data.count);

      // Still in limit period - return time when they can generate again
      const resetTime = new Date(limitTime.getTime() + 24 * 60 * 60 * 1000);
      const event = new CustomEvent("imageError", {
        detail: {
          type: "IMAGE_LIMIT_ERROR",
          message: "Du har nått din dagliga gräns för bildgenerering.",
          resetTime: resetTime.getTime(),
        },
      });
      window.dispatchEvent(event);
      return false;
    } else {
      // 24 hours passed - reset counter
      await updateDoc(userRef, {
        count: 1,
        limitHitTime: null,
      });
      return true;
    }
  }

  // No limit hit yet - check if they're about to hit it
  if (data.count >= process.env.REACT_APP_IMAGE_GENERATION_LIMIT) {
    // They just hit the limit - record the time
    await updateDoc(userRef, {
      limitHitTime: Timestamp.now(),
    });

    const resetTime = new Date(Date.now() + 24 * 60 * 60 * 1000);
    const event = new CustomEvent("imageError", {
      detail: {
        type: "IMAGE_LIMIT_ERROR",
        message: "Du har nått din dagliga gräns på 20 bilder.",
        resetTime: resetTime.getTime(),
      },
    });
    window.dispatchEvent(event);
    return false;
  }

  // Haven't hit limit - increment counter
  await updateDoc(userRef, {
    count: increment(1),
  });
  return true;
}

export async function generateAndProcessImage(prompt, userId, options = {}) {
  const {
    size = "1024x1024",
    model = "dall-e-3",
    quality = "standard",
    responseFormat = "url",
  } = options;

  try {
    await trackLesson(userId, "ImageGenerator.js", null, null);
    const withinLimit = await checkLessonLimit(userId, "ImageGenerator.js");
    if (!withinLimit) {
      return false;
    }
    // const canGenerate = await checkImageLimit(userId);
    // if (!canGenerate) {
    //   return null; // checkImageLimit already handled the error event & dialog
    // }

    Logger.log("prompt från generateAndProcessImage: ", prompt);

    // Generate the image using the OpenAI API
    const response = await generateImage(
      prompt,
      userId,
      size,
      model,
      1,
      quality,
      responseFormat,
    );

    if (
      !response ||
      !Array.isArray(response.data) ||
      response.data.length === 0
    ) {
      throw new Error("Invalid response from OpenAI API");
    }

    const imageUrl = response.data[0].url;
    const revisedPrompt = response.data[0].revised_prompt;

    // Process the image on your server
    const API_URL =
      process.env.NODE_ENV === "production"
        ? "/api"
        : "http://localhost:3001/api";
    const processResponse = await fetch(`${API_URL}/process-image`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        imageUrl,
        userId,
        prompt,
        size,
        model,
        quality,
        revisedPrompt,
      }),
    });

    if (!processResponse.ok) {
      throw new Error("Failed to process image on server");
    }

    const processedData = await processResponse.json();
    return processedData.imageUrl;
  } catch (error) {
    const errorMessage =
      error.response?.data?.details ||
      error.response?.data?.error ||
      error.message ||
      "An error occurred while generating or processing the image. Please try again.";

    const enhancedError = new Error(errorMessage);
    enhancedError.status = error.response?.status;
    enhancedError.response = error.response;
    enhancedError.originalError = error;

    throw enhancedError;
  }
}

export async function generateAndProcessImageWithRevision(
  prompt,
  userId,
  options = {},
) {
  const {
    size = "1024x1024",
    model = "dall-e-3",
    quality = "standard",
    responseFormat = "url",
  } = options;

  try {
    await trackLesson(userId, "ImageGenerator.js", null, null);
    const withinLimit = await checkLessonLimit(userId, "ImageGenerator.js");
    if (!withinLimit) {
      return false;
    }

    Logger.log("prompt från generateAndProcessImage: ", prompt);

    // Generate the image using the OpenAI API
    const response = await generateImage(
      prompt,
      userId,
      size,
      model,
      1,
      quality,
      responseFormat,
    );

    if (
      !response ||
      !Array.isArray(response.data) ||
      response.data.length === 0
    ) {
      throw new Error("Invalid response from OpenAI API");
    }

    const imageUrl = response.data[0].url;
    const revisedPrompt = response.data[0].revised_prompt;

    // Process the image on your server
    const API_URL =
      process.env.NODE_ENV === "production"
        ? "/api"
        : "http://localhost:3001/api";

    const processResponse = await fetch(`${API_URL}/process-image`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        imageUrl,
        userId,
        prompt,
        size,
        model,
        quality,
        revisedPrompt,
      }),
    });

    if (!processResponse.ok) {
      throw new Error("Failed to process image on server");
    }

    const processedData = await processResponse.json();

    // Return both the URL and the revised prompt
    return {
      imageUrl: processedData.imageUrl,
      revisedPrompt: revisedPrompt,
    };
  } catch (error) {
    const errorMessage =
      error.response?.data?.details ||
      error.response?.data?.error ||
      error.message ||
      "An error occurred while generating or processing the image. Please try again.";

    const enhancedError = new Error(errorMessage);
    enhancedError.status = error.response?.status;
    enhancedError.response = error.response;
    enhancedError.originalError = error;
    throw enhancedError;
  }
}

/**
 * Decrease tokens by 50 for a specific user.
 * @param {string} userId - The user ID.
 * @returns {Promise<void>}
 */
export const flagUrls = {
  spanish:
    "https://firebasestorage.googleapis.com/v0/b/personae-2a07b.appspot.com/o/languages%2Fspanish.png?alt=media&token=f00096d3-7d17-40a9-a150-cfacd020e8de",
  french:
    "https://firebasestorage.googleapis.com/v0/b/personae-2a07b.appspot.com/o/languages%2Ffrench.png?alt=media&token=33db1b5d-0bed-411e-8438-430f5b866e50",
  german:
    "https://firebasestorage.googleapis.com/v0/b/personae-2a07b.appspot.com/o/languages%2Fgerman2.png?alt=media&token=c4e93701-918f-44af-85bc-5ee35dd5d935",
  swedish:
    "https://firebasestorage.googleapis.com/v0/b/personae-2a07b.appspot.com/o/languages%2Fswedish.png?alt=media&token=8a880d8f-8945-4064-9440-200999a568e1",
  english:
    "https://firebasestorage.googleapis.com/v0/b/personae-2a07b.appspot.com/o/languages%2Fenglish.png?alt=media&token=e6a8424c-6809-4566-aa03-732705d6c031",
  arabic: "/img/arabic.png",
};

export const formatUrlPart = (str) => {
  return str
    .replace(/\s+/g, "-")
    .replace(/[åä]/g, "a")
    .replace(/[ö]/g, "o")
    .replace(/[^a-z0-9-]/gi, "")
    .toLowerCase();
};

export const formatUpvotes = (upvotes) => {
  if (upvotes == null) return "0"; // Handle undefined or null

  const num = parseInt(upvotes, 10);
  if (isNaN(num)) return "0"; // Handle non-numeric strings

  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, "") + "k";
  }
  return num.toString();
};

export const sanitizeInput = (input) => {
  if (typeof input !== "string") {
    return "";
  }

  // Remove HTML tags
  let sanitized = input.replace(/<[^>]*>/g, "");

  // Encode special characters, excluding single quotes
  sanitized = sanitized
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

  return sanitized;
};

export async function decreaseTokens(userId) {
  const userDocRef = doc(db, "users", userId);

  try {
    await updateDoc(userDocRef, {
      tokens: increment(-50),
    });
    Logger.log("Tokens successfully decreased by 50.");
  } catch (error) {
    console.error("Error decreasing tokens: ", error);
  }
}

export async function updateUserTokens(userId, tokens) {
  const isGuest = userId.startsWith("guest-");

  const collectionName = "users";
  const userDocRef = doc(db, collectionName, userId);
  try {
    await updateDoc(userDocRef, {
      tokens: increment(tokens),
    });
    Logger.log(
      "Tokens successfully increased by ",
      tokens,
      " for user ",
      userId,
      " which is guest ",
      isGuest,
    );
  } catch (error) {
    console.error("Error updating tokens: ", error);
  }
}

export const createUrlSlug = (name) => {
  return name
    .toLowerCase()
    .replace(/å/g, "a")
    .replace(/ä/g, "a")
    .replace(/ö/g, "o")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
};

export const formatDate = (timestamp) => {
  let date;

  if (timestamp && typeof timestamp.toDate === "function") {
    // Firestore Timestamp
    date = timestamp.toDate();
  } else if (typeof timestamp === "number") {
    // Unix timestamp in milliseconds (like Date.now())
    date = new Date(timestamp);
  } else {
    console.error("Unexpected timestamp format:", timestamp);
    return "Okänt datum";
  }

  if (isNaN(date.getTime())) {
    console.error("Invalid date:", timestamp);
    return "Okänt datum";
  }

  const now = new Date();
  const diffInDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));

  if (diffInDays === 0) {
    const distance = formatDistanceToNow(date, { addSuffix: true, locale: sv });
    // Custom shortening logic
    return distance
      .replace("ungefär ", "")
      .replace(" sekunder", " sek")
      .replace(" minuter", " min")
      .replace(" timmar", " tim")
      .replace(" timme", " timme")
      .replace("mindre än en minut", "< 1 min");
  } else if (diffInDays === 1) {
    return "Igår";
  } else if (diffInDays < 7) {
    return `${diffInDays} dagar sedan`;
  } else {
    return format(date, "d MMM yyyy", { locale: sv });
  }
};

export const features = [
  {
    showFor: ["teacher"],
    title: "Generera lektioner med AI",
    url: "lektioner",

    titleSEO: "Generera lektioner och pedagogiskt material på nolltid",
    description: "Skapa lektioner och pedagogiskt material med AI på nolltid",
    descriptionSEO:
      "Generera lektioner och pedagogiskt material med AI på nolltid",
    descriptionLonger:
      "Generera lektioner med AI på valfritt språk. Spara i din egen lektionsbank. Dela med kollegor eller elever. Översätt och anpassa svårighetsgraden. Eller skriv ut.",
    aboutText: "",
    icon: "<ChatIcon />",
    img: {
      light: "/img/hero-teacher.png",
      dark: "/img/hero-teacher.png",
    },
    heroImage: {
      light: "/img/flerval.png",
      dark: "/img/fraga-ai-hero-video-l.mp4",
    },

    examples: [
      {
        exampleText: "Rollkort",
        exampleUrl: "/app/lektioner/rollkort/3SyIOgeY4S?v=t",
      },

      {
        exampleText: "Fiktiv nyhet",
        exampleUrl: "/app/lektioner/fiktiva-nyhetsredaktionen/Ejd2EkHBq9?v=t",
      },
      {
        exampleText: "Fiktiv dagbok",
        exampleUrl: "/app/lektioner/fiktiva-dagbocker/yKWqpAE5Jj?v=t",
      },

      {
        exampleText: "Argumenterande text",
        exampleUrl:
          "/app/lektioner/lasforstaelse/ug3txMBUZY?type=argumentativeText&v=t",
      },
    ],

    details: [
      {
        text: "Genererar lektioner baserat på valfritt underlag: Du börjar med att välja exempelvis ett ämnesområde från Skolverkets kursplan, uppladdat dokument, artikel från SO-rummet eller helt egna instruktioner.",
        icon: <GenerateIcon />,
      },
      // {
      //   text: "Årskurs och språk: Specificera vilken årskurs och i vilket språk du vill att lektionen ska genereras på.",
      //   icon: <PersonOffIcon />,
      // },
      {
        text: "Redigera materialet & generera bilder: Anpassa det genererade materialet utifrån dina behov. Generera bilder och justera texten.",
        icon: <EditIcon />,
      },
      // {
      //   text: "Generera engagerande bilder: Med vår bildgenerator kan du snabbt generera engagerande bilder till dina lektioner.",
      //   icon: <LockIcon />,
      // },
      {
        text: "Dela med elever, spara i din egen lektionsbank, eller skriv ut: Du kan enkelt dela allt material som du genererar med dina elever. Allt du behöver göra är att du skapar ett elevrum, bjuder in eleverna att skapa ett konto via en specifik länk. Därefter kan du dela till alla eller enskilda elever.",
        icon: <ShareIcon />,
      },
    ],
  },

  {
    showFor: ["teacher"],
    title: "Generera interaktiva lektioner",
    titleSEO:
      "Generera interaktiva lektioner så som escape rooms, tidslinjer och Jeopardy med AI",
    description: "Skapa interaktiva lektioner så som Jeopardy & Escape Rooms.",
    descriptionSEO:
      "Skapa interaktiva lektioner med AI så som Jeopardy, Escape rooms och tidslinjer.",
    descriptionLonger: "",
    highightedWord: "interaktiva",
    aboutText: "",
    icon: "<ChatIcon />",
    img: {
      light: "/img/jeopardy.png",
      dark: "/img/jeopardy.png",
    },
    heroImage: {
      light: "/img/flerval.png",
      dark: "/img/fraga-ai-hero-video-l.mp4",
    },

    details: [
      {
        text: "Jeopardy: Designa ett frågespel där eleverna kan testa sina kunskaper i ett spännande format med kategorier och poängsystem.",
        icon: <EmojiEventsIcon />,
        exampleUrl: "/app/lektioner/jeopardy/EYTEmQ8kkg?v=t",
      },

      {
        text: "Escape Rooms: Skapa interaktiva escape rooms där eleverna löser gåtor och hittar ledtrådar för att låsa upp nya steg. Perfekt för problemlösning och grupparbete.",
        icon: <PsychologyIcon />,
        exampleUrl: "/app/lektioner/escape-room/4e6ZynliJb?v=t",
      },
      {
        text: "Tidslinjer: Generera visuella och interaktiva tidslinjer som hjälper eleverna att förstå historiska händelser, utveckling eller processer över tid.",
        icon: <TimelineIcon />,
        exampleUrl: "/app/lektioner/bygg-tidslinjer/AlgbciqgXZ?v=t",
      },

      {
        text: "Dela med elever: Dela de interaktiva lektionerna till eleverna så de kan lära sig på ett nytt, engagerande och spännande sätt.",
        icon: <ShareIcon />,
      },
    ],
  },

  {
    showFor: ["teacher"],
    title: "Dela materialet med dina elever",
    titleSEO: "Dela allt AI-genererat material med elever",
    // description:
    // "Dela allt pedagogiskt material du genererar med elever och lärare",
    descriptionSEO: "",
    descriptionLonger: "",
    aboutText: "",

    icon: "<ChatIcon />",
    // video: {
    //   light: "/img/fai-l.mp4",
    //   dark: "/img/fai-d.mp4",
    // },
    img: {
      light: "/img/dela 2.png",
      dark: "/img/dela 2.png",
    },

    heroImage: {
      light: "/img/flerval.png",
      dark: "/img/fraga-ai-hero-video-l.mp4",
    },
    details: [
      {
        text: "Skapa elevrum och bjud in dina elever: Du kan enkelt skapa ett elevrum, anpassa elevernas tillgång i systemet och bjuda in dem via Google Classroom, inbjudningslänk eller QR-kod.",
        icon: <GoogleIcon />,
      },
      {
        text: "Total kontroll över vad eleverna ser: Du bestämmer precis vilka verktyg som eleven kan se när de loggar in på Studera.ai.",
        icon: <LockOpenIcon />,
      },
      {
        text: "Tydlig översikt: Du som lärare kan se vilka elever som öppnat materialt du delat med dem, samt vid vilken tidpunkt. Du kan även se detaljerade resultat för exempelvis prov/quiz samt flashcards.",
        icon: <GridViewIcon />,
      },

      {
        text: "Skicka med kommentar och fil: Om du vill kan du skicka med en kompletterande kommentar och fil. Detta är perfekt om du har skapat en specifik lektion för några elever med särskilda behov.",
        icon: <EmailIcon />,
      },

      {
        text: "Anpassa lektionskort: Gör lektionen mer inbjudande genom att anpassa lektionskortet som eleverna ser när lektionen delas.",
        icon: <ShareIcon />,
      },
    ],
  },

  {
    showFor: ["teacher"],
    title: "Generera quiz med AI",
    url: "quiz",
    //description: "Generera läxförhör baserat på ditt studiematerial.",
    titleSEO: "Generera prov & quiz med AI",
    descriptionSEO:
      "Generera skräddarsydda quiz med AI för att testa och förstärka din kunskap. Perfekt för läxförhör. Anpassa frågor, följ dina framsteg och förbättra din inlärningsupplevelse.",
    descriptionLonger:
      "Generera ett quiz med AI baserat på eget underlag eller valfria instruktioner. Redigera, spara och dela med eleverna samt övervaka resultaten i realtid.",
    aboutText:
      'Vår quiz-funktion är utformad för att revolutionera hur du testar och förstärker din kunskap. Med hjälp av avancerad AI-teknologi kan du generera skräddarsydda quiz baserade på vilket ämne eller material som helst. Detta hjälper dig att effektivt repetera och befästa kunskap på ett sätt som är anpassat efter dina behov.\n\nDu kan ladda upp dina egna dokument eller använda YouTube-videor som grund för quiz-frågorna, vilket gör att du kan förvandla dina studie- eller undervisningsmaterial till interaktiva övningar. Med möjligheten att anpassa frågetyper, svårighetsgrad och antal frågor får du full kontroll över din inlärningsprocess.\n\nGenom att använda våra AI-genererade quiz kan du förbättra din förståelse för ämnet, identifiera områden som behöver ytterligare arbete och följa dina framsteg över tid. Detta gör inlärningen mer engagerande och effektiv, oavsett om du är student, lärare eller självlärande.\n\n Dessutom erbjuder vår quiz-funktion en unik AI-assistansfunktion som tar din inlärningsupplevelse till nästa nivå. När som helst under quizet kan du klicka på "Fråga AI" för att få djupgående, personligt anpassade förklaringar baserade på din nuvarande kunskapsnivå. Du kan be om förtydliganden, analogier eller ytterligare kontext för att bättre förstå frågorna och svaren. Denna interaktiva funktion fungerar som en personlig tutor, redo att hjälpa dig när du behöver det mest, vilket säkerställer att du inte bara memorerar information utan verkligen förstår och kan tillämpa den kunskap du förvärvar.',
    icon: <QuizIcon />,
    video: {
      light: "https://sportkuriren.se/wp-content/uploads/generera-fragor2.mp4",
      dark: "https://sportkuriren.se/wp-content/uploads/generera-fragor2.mp4",
    },

    img: {
      light: "/img/flerval.png",
      dark: "/img/flerval.png",
    },

    heroImage: {
      light: "https://sportkuriren.se/wp-content/uploads/generera-fragor2.mp4",
      dark: "https://sportkuriren.se/wp-content/uploads/generera-fragor2.mp4",
    },
    details: [
      {
        text: "Genererar frågor baserat på valfritt underlag: Generera prov/quiz baserat på ämne från Skolverkets kursplan, uppladdat dokument, artikel från SO-rummet eller helt egna instruktioner.",
        icon: <FactCheckIcon />,
      },
      {
        text: "Välj mellan 4 frågetyper: Prov där eleven skriver in sitt eget svar, flervalsfrågor med fördefinierade alternativ, sant eller falskt-frågor samt fyll-i-luckan.",
        icon: <QuestionAnswerIcon />,
      },

      {
        text: "Redigera och anpassa: Redigera frågorna, svarsalternativen och ledtrådarna utifrån elevernas kunskapsnivå.",
        icon: <MenuBookIcon />,
      },
      {
        text: "Dela med elever, skriv ut eller spara: Delar du med eleverna så blir provet interaktivt, väljer du att skriva ut det så kan du helt enkelt dela ut det i klassrummet, väljer du att spara kan du närsomhelst gå tillbaka och/eller anpassa för elever med specifika förutsättningar.",
        icon: <ShareIcon />,
      },

      {
        text: "Läxförhör: Perfekt för elever som vill testa sin kunskap inför prov. Välj mellan flervalsfrågor, sant/falskt eller fyll-i-luckan för att skapa varierade och effektiva läxförhör.",
        icon: <SchoolIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Framstegsövervakning: Följ dina resultat över tid för att identifiera styrkor och svagheter, vilket hjälper dig att fokusera på områden som behöver förbättras.",
        icon: <TrendingUpIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Spara och organisera: Lagra dina quiz och resultat på ett strukturerat sätt för enkel åtkomst och uppföljning av din inlärningsprogression.",
        icon: <FolderIcon />,
        showInFeaturePage: true,
      },

      {
        text: "Fråga AI: Klicka när som helst på 'Fråga AI' för att få detaljerade förklaringar anpassade efter din kunskapsnivå, be om analogier eller få ytterligare kontext för att bättre förstå frågorna och fördjupa ditt lärande.",
        icon: <LiveHelpIcon />,
        showInFeaturePage: true,
      },

      {
        text: "Ta del av andra användares quiz: Utforska och använd quiz skapade av andra användare för att få tillgång till ett brett utbud av ämnen och perspektiv, vilket berikar din inlärningsupplevelse och ger möjlighet att testa din kunskap inom nya områden.",
        icon: <PeopleIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Ledtrådar: Klicka på 'Ledtråd'-knappen när du behöver lite extra hjälp. Få smarta och relevanta ledtrådar som guidar dig mot rätt svar utan att avslöja det helt, så inlärningsprocessen blir mer engagerande.",
        icon: <EmojiObjectsIcon />,
        showInFeaturePage: true,
      },
    ],
    pros: [
      {
        text: "Effektiviserar inlärningsprocessen med interaktiva quiz",
        icon: <SpeedIcon />,
      },
      {
        text: "Anpassad inlärning efter dina specifika behov",
        icon: <AccessibilityNewIcon />,
      },
      {
        text: "Förbättrar kunskapsretention och förståelse",
        icon: <EmojiObjectsIcon />,
      },
    ],
    steps: [
      {
        title: "Välj ämne eller ladda upp material",
        description:
          "Börja med att ange ett ämne, ladda upp ett dokument eller ange en YouTube-länk.",
      },
      {
        title: "Generera quiz med AI",
        description:
          "Anpassa dina inställningar såsom frågetyper, svårighetsgrad, AI-modell och antal frågor, och låt AI generera quizet.",
      },
      {
        title: "Genomför quizet och följ dina framsteg",
        description:
          "Svara på frågorna, få omedelbar feedback och se dina resultat för att identifiera områden för förbättring.",
      },
    ],
    typeAnimationSequence: [
      "Generera skräddarsydda quiz med AI ",
      1000,
      "Anpassa frågetyper och svårighetsgrad ",
      1000,
      "Förvandla dina dokument till interaktiva quiz ",
      1000,
      "Förbättra din kunskapsretention ",
      1000,
      "Följ dina framsteg över tid ",
      1000,
      "Gör inlärningen roligare och mer effektiv ",
      1000,
      "Få AI-assistans när du behöver det ",
      1000,
    ],
  },

  {
    showFor: ["teacher"],
    title: "Generera flashcards med AI",
    url: "flashcards",
    titleSEO: "Generera  flashcards med AI",
    //description: "Interaktiva flashcards baserat på valfritt underlag",
    descriptionSEO:
      "Skapa anpassade flashcards med AI för effektiv inlärning. Generera flashcards från dokument, videor eller valfritt ämne för att förbättra din studieteknik.",
    descriptionLonger:
      "Generera skräddarsydda flashcards baserat på ditt studiematerial med hjälp av AI. Skapa flashcards från dokument, YouTube-videor eller valfritt ämne för att effektivisera din inlärning och förbättra minnesbehållning.",
    aboutText:
      'Genom att använda avancerad AI-teknologi kan du snabbt och enkelt skapa effektiva flashcards från valfritt studiematerial eller ämne.\n\nDu kan ladda upp dina egna dokument, använda YouTube-videor som källa, skriva in en valfri URL, eller helt enkelt ange ett ämne för att generera relevanta flashcards. Detta gör det möjligt att omvandla all typ av inlärningsmaterial till interaktiva flashcards som hjälper dig att bättre förstå och komma ihåg viktiga koncept.\n\nMed möjligheten att anpassa dina flashcards och implementera principen om distribuerad repetition, optimerar du din inlärningsprocess och förbättrar din långsiktiga minnesbehållning. Detta gör flashcards-funktionen till ett ovärderligt verktyg för studenter, yrkesverksamma och andra som vill effektivisera sin kunskapsinhämtning.\n\nDessutom får du tillgång till en unik Fråga AI-funktion som fördjupar din inlärning där du kan ställa frågor för att förstå mer om ämnet i fråga, så när du går igenom dina flashcards kan du när som helst klicka på "Fråga AI" för att få djupgående, personligt anpassade förklaringar. Du kan be om förtydliganden, exempel eller ytterligare kontext för att bättre förstå informationen på kortet. Detta interaktiva element fungerar som en personlig lärare, redo att hjälpa dig fördjupa din förståelse och koppla samman olika koncept, vilket säkerställer att du inte bara memorerar fakta utan verkligen förstår och kan tillämpa kunskapen.',
    icon: <ViewAgendaIcon />,
    //video: { light: "/img/f-l.mp4", dark: "/img/f-d.mp4" },

    img: {
      light: "/img/flash.png",
      dark: "/img/flash.png",
    },

    heroImage: {
      light: "/img/flashcards-hero-video-l.mp4",
      dark: "/img/flashcards-hero-video-l.mp4",
    },
    details: [
      {
        text: "Genererar flashcards baserat på valfritt underlag: Generera flashcards baserat på ämne från Skolverkets kursplan, uppladdat dokument, artikel från SO-rummet eller helt egna instruktioner.",
        icon: <FactCheckIcon />,
      },

      {
        text: "Redigera och anpassa: Redigera flashcards utifrån elevernas specifika behov, möjlighet att lägga till bilder till fram- och baksida föra att främja visuell inlärning.",
        icon: <MenuBookIcon />,
      },

      {
        text: "Välj mellan 50 olika språk: Generera flashcards på över 50 olika språk.",
        icon: <LanguageIcon />,
      },
      {
        text: "Distribuerad repetition: Vi använder principen om distribuerad repetition för att förbättra  minnesbehållningen och optimera elevens inlärningsprocess.",
        icon: <TrendingUpIcon />,
      },
      {
        text: "Dela med elever och se resultat: När eleven påbörjar träningen kan du se resultaten, d.v.s. vilka flashcards de markerat som lätta eller svåra.",
        icon: <ShareIcon />,
      },

      {
        text: "Anpassningsbara flashcards: Skräddarsy dina flashcards genom att redigera framsida och baksida, lägga till bilder eller ändra svårighetsgrad för att matcha dina inlärningsbehov.",
        icon: <TuneIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Följ dina framsteg: Följ dina resultat och inlärningskurva över tid för att identifiera områden som behöver mer fokus och se din förbättring.",
        icon: <AssessmentIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Dela och samarbeta: Dela dina flashcards-samlingar med andra användare för att berika allas inlärningsupplevelse.",
        icon: <ShareIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Fråga AI: Använd 'Fråga AI'-funktionen när du går igenom dina flashcards för att få djupgående förklaringar, exempel eller ytterligare kontext anpassad efter din kunskapsnivå.",
        icon: <LiveHelpIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Ledtrådar: Be om AI-genererade ledtrådar innan du vänder på kortet för att göra upplevelsen med engagerande.",
        icon: <EmojiObjectsIcon />,
        showInFeaturePage: true,
      },
    ],
    pros: [
      {
        text: "Effektiviserar skapandet av studiematerial",
        icon: <SpeedIcon />,
      },
      {
        text: "Förbättrar minnesretention genom aktiv repetition",
        icon: <MemoryIcon />,
      },
      {
        text: "Anpassningsbar för olika inlärningsstilar och ämnen",
        icon: <TuneIcon />,
      },
    ],
    steps: [
      {
        title: "Välj källa eller ange ämne",
        description:
          "Börja med att välja en källa (dokument, video, URL) eller ange ett specifikt ämne för dina flashcards.",
      },
      {
        title: "Generera flashcards med AI",
        description:
          "Låt AI generera flashcards baserat på din input. Granska och anpassa korten efter behov.",
      },
      {
        title: "Studera och förbättra",
        description:
          "Använd dina flashcards regelbundet, följ dina framsteg och använd AI-assistans för djupare förståelse.",
      },
    ],
    typeAnimationSequence: [
      "Skapa anpassade flashcards med AI ",
      1000,
      "Generera kort från dokument eller videor ",
      1000,
      "Förbättra din minnesretention ",
      1000,
      "Studera effektivt var som helst ",
      1000,
      "Följ dina framsteg över tid ",
      1000,
      "Få AI-assistans för djupare förståelse ",
      1000,
      "Optimera din inlärning med flashcards ",
      1000,
    ],
  },

  {
    showFor: ["teacher"],
    title: "Generera lektionsplaneringar",
    titleSEO: "Generera lektionsplaneringar med AI",
    description: "Generera estetiskt tilltalande lektionsplaneringar",
    descriptionSEO: "",
    descriptionLonger: "",
    aboutText: "",

    icon: "<ChatIcon />",
    // video: {
    //   light: "/img/fai-l.mp4",
    //   dark: "/img/fai-d.mp4",
    // },
    img: {
      light: "/img/lektionsplaneringar.png",
      dark: "/img/lektionsplaneringar.png",
    },

    heroImage: {
      light: "/img/flerval.png",
      dark: "/img/fraga-ai-hero-video-l.mp4",
    },

    examples: [
      {
        exampleText: "Exempel #1",
        exampleUrl: "/app/lektioner/lektionsplan/gg7LkcnVjA?v=t",
      },

      {
        exampleText: "Exempel #2",
        exampleUrl: "/app/lektioner/lektionsplan/Hl5H5l8UE4?v=t",
      },
      {
        exampleText: "Exempel #3",
        exampleUrl: "/app/lektioner/lektionsplan/rj8gNqDxZv?v=t",
      },
    ],

    details: [
      {
        text: "Valfritt underlag: Generera din lektionsplanering baserat på ämne från Skolverkets kursplan, en bok från Kulturrådets boklistor eller baserat på helt egna instruktioner.",
        icon: <GenerateIcon />,
      },
      {
        text: "Välj årskurs, språk och lektionstid: Lektionsplaneringen kommer anpassas utifrån dina krav och lektionstid.",
        icon: <AccessTimeIcon />,
      },
      {
        text: "Redigera och spara: Du har frihet att redigera, ta bort och lägga till delar i lektionsplaneringen så den lämpar sig utifrån dina önskningar. Därefter kan du spara den i din egen lektionsbank.",

        icon: <EditIcon />,
      },
      {
        text: "Dela med andra lärare: Dela med en kollega om du känner att vederbörande kommer ha nytta av den. Givetvis kan du även dela med elever.",
        icon: <ShareIcon />,
      },
      // {
      //   text: "Skriv ut: Givetvis kan du närsomhelst skriva ut lektionsplanen.",
      //   icon: <PrintIcon />,
      // },
    ],
  },

  {
    showFor: ["student"],
    title: "Högskoleprovet med AI",
    url: "hogskoleprovet",
    titleSEO: "Öva på gamla högskoleprov med stöd från AI",
    description: "Öva på gamla högskoleprov med stöd från AI",
    descriptionSEO: "Öva på gamla högskoleprov med stöd från AI helt gratis.",
    descriptionLonger:
      "Öva på högskoleprovet med AI som stöd för att öka din förståelse. Få tillgång till alla gamla högskoleprov och förbered dig inför provet. Helt gratis!",
    aboutText: "",

    icon: "<HistoryEduIcon />",
  },

  {
    showFor: ["teacher"],
    url: "bedomning",
    title: "Bedömning med AI",
    titleSEO: "Bedömning med AI",

    description: "Rättvisa och objektiva omdömen för elevers texter",
    descriptionSEO:
      "Spara tid och få hjälp att rättvist och objektivt bedöma elevers texter med AI. Anpassa omdömen, spara för smidig hantering, och säkerställ konsekvent bedömning.",
    descriptionLonger:
      "Spara tid och säkerställ rättvisa bedömningar med AI. Använd färdiga bedömningsmatriser eller skapa egna - få detaljerad feedback för varje elev automatiskt.",

    aboutText:
      "Vår funktion för att betygsätta uppsatser med AI är utformad för att förändra sättet lärare bedömer elevers arbete. Genom att utnyttja den senaste AI-teknologin kan du spara värdefull tid och säkerställa en objektiv, rättvis och konsekvent bedömning av alla uppsatser.\n\nAI analyserar texterna med hjälp av fördefinierade eller anpassade bedömningsmatriser, vilket minskar risken för partiskhet och garanterar att varje elev bedöms utifrån samma kriterier.\n\nAtt betygsätta uppsatser med AI gör din bedömningsprocess snabbare, mer konsekvent och rättvis – samtidigt som du behåller kontrollen över den slutgiltiga bedömningen. Detta frigör även resurser för lärare att fokusera på att ge individuell feedback, planera lektioner och stödja elevernas utveckling.",
    icon: <InsertDriveFileIcon />,
    // video: {
    //   light: "/img/betygsatt-uppsatser-l.mp4",
    //   dark: "/img/betygsatt-uppsatser-d.mp4",
    // },
    img: {
      light: "/img/omdome-larare.png",
      dark: "/img/omdome-larare.png",
    },

    heroImage: {
      light: "/img/uppsatser-hero-image-l.png",
      dark: "/img/uppsatser-hero-image-l.png",
    },

    details: [
      {
        text: "Bedöm texter med AI: Använd AI för att analysera texter utifrån fördefinierade eller egenskapade bedömningsmatriser, vilket säkerställer objektiv och konsekvent bedömning.",
        icon: <AutoFixHighIcon />,
      },
      {
        text: "Anpassningsbara omdömen: Granska och redigera omdömen för att säkerställa att bedömningen passar varje enskild elevs arbete och utvecklingsbehov.",
        icon: <CreateIcon />,
      },

      {
        text: "Konsekvent bedömning: Säkerställ att alla texter bedöms utifrån samma kriterier, vilket främjar rättvisa och transparens i bedömningsprocessen.",
        icon: <BalanceIcon />,
      },
      {
        text: "Spara och organisera: Lagra bedömningar och omdömen på ett strukturerat sätt för enkel åtkomst, uppföljning och dokumentation av elevers progression över tid.",
        icon: <FolderIcon />,
      },
      {
        text: "Tillgång till eget arkiv: Tillgång till ett eget arkiv över bedömningar där du enkelt kan markera dem du granskat, samt gå tillbaka och redigera vid behov. Exportera eller skriv ut.",
        icon: <AssessmentIcon />,
      },
    ],
    pros: [
      {
        text: "Sparar tid och effektiviserar bedömningsprocessen",
        icon: <SpeedIcon />,
      },
      {
        text: "Säkerställer konsekvent och rättvis bedömning",
        icon: <VerifiedUserIcon />,
      },
      {
        text: "Ger lärare mer tid att fokusera på individuell feedback och stöd",
        icon: <PeopleIcon />,
      },
    ],
    steps: [
      {
        title: "Ladda upp uppsats",
        description:
          "Ladda upp elevens uppsats eller klistra in texten direkt i systemet.",
        image: "/img/uppsatser-steg-1-l.png",
      },
      {
        title: "AI-analys",
        description:
          "AI analyserar uppsatsen baserat på valda bedömningskriterier och genererar ett förslag på omdöme.",
        image: "/img/uppsatser-steg-2-l.png",
      },
      {
        title: "Granska och anpassa",
        description:
          "Granska AI:ns förslag, gör nödvändiga justeringar och lägg till personlig feedback.",
        image: "/img/uppsatser-steg-3-l.png",
      },
    ],
    typeAnimationSequence: [
      "Spara tid vid bedömning av uppsatser ",
      1000,
      "Säkerställ konsekvent och rättvis bedömning ",
      1000,
      "Anpassa AI-genererade omdömen ",
      1000,
      "Fokusera på att ge värdefull feedback ",
      1000,
      "Organisera och spara bedömningar enkelt ",
      1000,
      "Följ elevers progression över tid ",
      1000,
    ],
  },

  {
    showFor: ["teacher"],
    title: "Skapa bedömningsmatriser",
    titleSEO: "Skapa bedömningsmatriser med AI",
    description:
      "Skräddarsydda bedömningsmatriser för att standardisera bedömningen av texter.",
    descriptionSEO:
      "Skapa anpassade bedömningsmatriser med AI för att standardisera och förtydliga bedömningen av uppsatser. Säkerställ konsekvent och rättvis bedömning.",
    descriptionLonger:
      "Skapa skräddarsydda bedömningsmatriser med AI för att standardisera och tydliggöra bedömningen av uppsatser. Anpassa kriterier, spara för framtida bruk, och säkerställ konsekvent bedömning av alla uppsatser.",
    aboutText:
      "Vår funktion för att skapa bedömningsmatriser med AI är utformad för att revolutionera hur lärare utformar och använder bedömningskriterier. Genom att utnyttja avancerad AI-teknologi kan du snabbt och enkelt skapa detaljerade, anpassade matriser som säkerställer en konsekvent och rättvis bedömning av elevers arbete.\n\nAI hjälper dig att definiera tydliga kriterier och betygsnivåer, vilket minskar subjektivitet i bedömningsprocessen och ger eleverna en klar förståelse för förväntningarna. Du kan enkelt anpassa matriserna efter specifika uppgifter eller ämnesområden, spara dem för framtida bruk, och dela dem med kollegor för att främja en enhetlig bedömningsstandard.\n\nAtt skapa bedömningsmatriser med AI effektiviserar ditt arbete, förbättrar transparensen i bedömningsprocessen, och ger dig mer tid att fokusera på att ge värdefull feedback och stöd till dina elever.",
    icon: <CreateIcon />,
    // video: {
    //   light: "/img/bedomningsmatriser-l.mp4",
    //   dark: "/img/bedomningsmatriser-d.mp4",
    // },

    img: {
      light: "/img/skapa bedömningsmatris.png",
      dark: "/img/skapa bedömningsmatris.png",
    },
    heroImage: {
      light: "/img/bedomningsmatriser-hero-image-l.png",
      dark: "/img/bedomningsmatriser-hero-image-d.png",
    },
    details: [
      {
        text: "Skapa strukturerade matriser: Skapa anpassade bedömningsmatriser baserade på dina specifika krav och ämnesområden.",
        icon: <AutoFixHighIcon />,
      },
      {
        text: "Flexibla kriterier: Lägg enkelt till, redigera eller ta bort bedömningskriterier för att skapa matriser som perfekt matchar dina pedagogiska mål.",
        icon: <TuneIcon />,
      },
      {
        text: "Detaljerade betygsnivåer: Definiera tydliga beskrivningar för varje betygsnivå (A-F) inom varje kriterium för att säkerställa noggrann och konsekvent bedömning.",
        icon: <GradeIcon />,
      },
      {
        text: "Spara och återanvänd: Lagra dina skapade matriser för enkel åtkomst och återanvändning, vilket sparar tid och upprätthåller konsekvens över tid.",
        icon: <SaveIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Konsekvent bedömning: Använd dina matriser för att säkerställa att alla texter bedöms utifrån samma kriterier, vilket främjar rättvisa och opartiskhet.",
        icon: <BalanceIcon />,
      },
      {
        text: "Snabbare bedömningsprocess: Effektivisera din bedömning genom att ha fördefinierade kriterier, vilket sparar tid och gör processen mer strömlinjeformad.",
        icon: <AccessTimeIcon />,
        showInFeaturePage: true,
      },
    ],
    pros: [
      {
        text: "Effektiviserar skapandet av bedömningsmatriser",
        icon: <SpeedIcon />,
      },
      {
        text: "Säkerställer konsekvent och rättvis bedömning",
        icon: <BalanceIcon />,
      },
      {
        text: "Ökar transparens i bedömningsprocessen för elever",
        icon: <VisibilityIcon />,
      },
    ],
    steps: [
      {
        title: "Skapa bedömningsmatris",
        description:
          "Börja med att ge din matris ett namn som återspeglar uppgiftens fokus.",
        //image: '/img/bedomningsmatriser-steg-1-l.png',
      },
      {
        title: "Definiera kriterier",
        description:
          "Definiera de kriterier som ska bedömas och ange betygsnivåer samt detaljerade beskrivningar för varje nivå.",
        //image: '/img/bedomningsmatriser-steg-2-l.png',
      },
      {
        title: "Använd för att betygsätta uppsats",
        description:
          "När du laddar upp en uppsats kan du enkelt återanvända dina skapade bedömningskriterier för konsekvent bedömning.",
        //image: '/img/bedomningsmatriser-steg-3-l.png',
      },
    ],
    typeAnimationSequence: [
      "Skapa anpassade bedömningsmatriser ",
      1000,
      "Definiera tydliga kriterier ",
      1000,
      "Säkerställ konsekvent bedömning ",
      1000,
      "Spara och återanvänd matriser ",
      1000,
      "Dela med kollegor ",
      1000,
      "Öka transparens för elever ",
      1000,
    ],
  },

  {
    showFor: ["teacher"],
    title: "Tryggt och säkert lärande, även med AI-teknologi",
    titleSEO: "Tryggt och säkert lärande, även med AI-teknologi",
    description: "Datasäkerhet är en av våra högsta prioriteringar.",
    descriptionSEO: "Säkert lärande med AI för skolan",
    descriptionLonger:
      "Vi säkerställer att din data hanteras på ett tryggt och säkert sätt. Elevernas information anonymiseras, och vi delar aldrig personlig information som namn eller identifierande uppgifter. Vi har dessutom valt att inte dela data med OpenAI för modellträning, så du kan känna dig trygg med vår lösning.",
    aboutText:
      "Studera.ai bygger på en säkerhetsfokuserad plattform som skyddar både lärare och elever från dataläckor och missbruk av information. Vår tjänst följer GDPR och andra relevanta dataskyddslagar. Genom att använda anonymiserade data och opt-out från modellträning hos OpenAI, kan vi erbjuda kraftfulla AI-verktyg utan att kompromissa på integritet.",
    icon: "<ChatIcon />",
    img: {
      light: "/img/gdpr.png",
      dark: "/img/gdpr.png",
    },
    heroImage: {
      light: "/img/flerval.png",
      dark: "/img/fraga-ai-hero-video-l.mp4",
    },
    details: [
      {
        text: "GDPR-säker plattform: Vi följer strikt dataskyddslagstiftning för att skydda elever och lärare.",
        icon: <ShieldIcon />,
      },
      {
        text: "Anonymisering av data: All data som skickas till AI anonymiseras och innehåller aldrig personlig information.",
        icon: <PersonOffIcon />,
      },
      {
        text: "Ingen datadelning: Vi delar aldrig elev- eller lärardata med andra tredje parter.",
        icon: <StopScreenShareIcon />,
      },
      {
        text: "Opt-out från modellträning: Våra förfrågningar till AI-modeller används inte för att förbättra deras modeller. ",
        icon: <LockIcon />,
      },
      {
        text: "Transparent datasäkerhet: Vi är öppna med hur din data hanteras och ger full kontroll till användaren.",
        icon: <VisibilityIcon />,
      },
    ],
  },

  {
    showFor: ["teacher"],
    title: "Lektioner i enlighet med Skolverkets kursplan",
    titleSEO: "Lektioner i enlighet med Skolverkets kursplan",
    description: "Vi har koll på alla styrdokument från Skolverket.",
    descriptionSEO: "Lektioner i enlighet med Skolverkets kursplan",
    // descriptionLonger:
    //   "Vi säkerställer att din data hanteras på ett tryggt och säkert sätt. Elevernas information anonymiseras, och vi delar aldrig personlig information som namn eller identifierande uppgifter. Vi har dessutom valt att inte dela data med OpenAI för modellträning, så du kan känna dig trygg med vår lösning.",
    // aboutText:
    //   "Studera.ai bygger på en säkerhetsfokuserad plattform som skyddar både lärare och elever från dataläckor och missbruk av information. Vår tjänst följer GDPR och andra relevanta dataskyddslagar. Genom att använda anonymiserade data och opt-out från modellträning hos OpenAI, kan vi erbjuda kraftfulla AI-verktyg utan att kompromissa på integritet.",
    icon: "<ChatIcon />",
    img: {
      light: "/img/enlighet med skolverkets kursplan 2.png",
      dark: "/img/enlighet med skolverkets kursplan 2.png",
    },
    heroImage: {
      light: "/img/flerval.png",
      dark: "/img/fraga-ai-hero-video-l.mp4",
    },
    details: [
      {
        text: "Anpassade lektioner: Generera lektioner som är i överensstämmelse med Skolverkets kursplan för respektive ämne och årskurs.",
        icon: <SchoolIcon />,
      },
      {
        text: "Stöd för anpassad skola: Du kan även generera lektioner som följer läroplanen för anpassad skola, så att alla elever kan inkluderas.",
        icon: <AllInclusiveIcon />,
      },

      {
        text: "Lägg till ytterligare instruktioner: Efter du valt ämnesområde från Skolverket kan du enkelt instruera Studera.ai att generera material utifrån dina behov för att få just det specfika ämnesområde du är ute efter. ",
        icon: <EditIcon />,
      },
      {
        text: "Trygghet i innehållet: Var säker på att allt material du genererar uppfyller kraven i kursplanen och styrdokumenten.",
        icon: <CheckIcon />,
      },
    ],
  },

  {
    showFor: ["teacher"],
    title: "Underlag till pedagogiskt material",
    titleSEO: "Underlag till pedagogiskt material",
    description:
      "Generera  material baserat på noggrant kurerade & pålitliga källor",
    descriptionSEO: "",
    descriptionLonger: "",
    aboutText: "",

    icon: "<ChatIcon />",
    // video: {
    //   light: "/img/fai-l.mp4",
    //   dark: "/img/fai-d.mp4",
    // },
    img: {
      light: "/img/underlag.png",
      dark: "/img/underlag.png",
    },

    heroImage: {
      light: "/img/flerval.png",
      dark: "/img/fraga-ai-hero-video-l.mp4",
    },
    details: [
      {
        text: "Skolverket kursplan: Välj ämne, årskurs och ämnesområde från Skolverkets kursplan.",

        icon: <SaveIcon />,
      },
      {
        text: "Kulturrådets läslistor: Basera ditt materal på Skolverkets och Kulturrådets läslistor.",
        icon: <MenuBookIcon />,
      },
      {
        text: "Webbadress/URL: Skriv in valfri URL och använd det som underlag till din lektion.",

        icon: <LinkIcon />,
      },
      {
        text: "SO-rummet: Använd SO-rummets lika eminenta som kortfattade artiklar om alla möjlig aämnen som underlag.",
        icon: <LanguageIcon />,
      },

      {
        text: "Ladda upp fil: Ladda upp valfri fil och generera ditt material",
        icon: <WordIcon2019 />,
      },
    ],
  },

  {
    showFor: ["teacher"],
    title: "Generera podcast med AI",
    url: "podcast",
    titleSEO: "Generera podcast",
    description: "Generera podcast baserat på valfritt underlag",
    descriptionSEO:
      "Generera en podcast med AI baserat på valfritt dokument, bild, URL eller egna instruktioner. Ladda ned eller dela.",
    descriptionLonger:
      "Generera en podcast med AI baserat på valfritt dokument, bild, URL eller egna instruktioner. Ladda ned eller dela.",
    aboutText: "",

    icon: "<MicIcon />",
    // video: {
    //   light: "/img/fai-l.mp4",
    //   dark: "/img/fai-d.mp4",
    // },
    img: {
      light: "https://sportkuriren.se/wp-content/uploads/collage.png",
      dark: "https://sportkuriren.se/wp-content/uploads/collage.png",
    },

    heroImage: {
      light: "/img/flerval.png",
      dark: "/img/fraga-ai-hero-video-l.mp4",
    },
    details: [
      {
        text: "Du har full kontroll: Skriv in exakt hur du vill att bilden ska se ut.",

        icon: <SaveIcon />,
      },
      {
        text: "Olika modeller: Välj mellan flera olika bildgeneratorer så som DALL-E 3, Imagen och MidJourney.",
        icon: <GenerateIcon />,
      },
      {
        text: "Personligt galleri: Få tillgång till ditt alldeles egna galleri med alla bilder du genererat.",

        icon: <ViewAgendaIcon />,
      },

      {
        text: "Teman och filter: Lägg till kreativa filter och stilar som matchar olika ämnen eller lektioner.",
        icon: <BlurOnIcon />,
      },
      {
        text: "Ladda ned: Du kan helt gratis ladda ned bilderna och använda till precis vad du vill",
        icon: <ImageIcon />,
      },
    ],
  },

  {
    showFor: ["teacher"],
    title: "Generera bilder",
    titleSEO: "Generera bilder",
    description: "Generera engagerande bilder till ditt lektionsmaterial",
    descriptionSEO: "",
    descriptionLonger: "",
    aboutText: "",

    icon: "<ChatIcon />",
    // video: {
    //   light: "/img/fai-l.mp4",
    //   dark: "/img/fai-d.mp4",
    // },
    img: {
      light: "https://sportkuriren.se/wp-content/uploads/collage.png",
      dark: "https://sportkuriren.se/wp-content/uploads/collage.png",
    },

    heroImage: {
      light: "/img/flerval.png",
      dark: "/img/fraga-ai-hero-video-l.mp4",
    },
    details: [
      {
        text: "Du har full kontroll: Skriv in exakt hur du vill att bilden ska se ut.",

        icon: <SaveIcon />,
      },
      {
        text: "Olika modeller: Välj mellan flera olika bildgeneratorer så som DALL-E 3, Imagen och MidJourney.",
        icon: <GenerateIcon />,
      },
      {
        text: "Personligt galleri: Få tillgång till ditt alldeles egna galleri med alla bilder du genererat.",

        icon: <ViewAgendaIcon />,
      },

      {
        text: "Teman och filter: Lägg till kreativa filter och stilar som matchar olika ämnen eller lektioner.",
        icon: <BlurOnIcon />,
      },
      {
        text: "Ladda ned: Du kan helt gratis ladda ned bilderna och använda till precis vad du vill",
        icon: <ImageIcon />,
      },
    ],
  },

  {
    showFor: ["teacher"],
    title: "Övningar baserat på lektionen",
    titleSEO: "Generera övningar baserat på lektionsinnehållet",
    description: "Lägg snabbt till övningar baserat på lektionsinnehållet",
    descriptionSEO: "Generera övningar baserat på lektionsinnehållet",
    descriptionLonger: "",
    aboutText: "",
    icon: "<ChatIcon />",
    img: {
      light: "/img/skapa övningar med ai.png",
      dark: "/img/skapa övningar med ai.png",
    },
    heroImage: {
      light: "/img/flerval.png",
      dark: "/img/fraga-ai-hero-video-l.mp4",
    },
    details: [
      {
        text: "I texten, mellan raderna & bortom raderna: Frågor för att utforska texten på flera nivåer. 'I texten' handlar om att hitta direkta svar, 'Mellan raderna' kräver slutsatser, och 'Bortom raderna' uppmuntrar till analys och egna tankar.",
        icon: <TextFieldsIcon />,
      },
      {
        text: "Sant eller falskt: Enkla påståenden för att snabbt bedöma elevers förståelse av ämnet eller texten.",
        icon: <FactCheckIcon />,
      },
      {
        text: "Flervalsfrågor & diskussionsfrågor: Kombinera frågor med flera svarsalternativ för att repetera och testa kunskap med öppna frågor som främjar djupare reflektion och gruppdiskussioner.",
        icon: <QuestionAnswerIcon />,
      },
      {
        text: "Ordförståelse & uppgifter: Ords betydelser, synonymer och antonymer i olika sammanhang. Samt praktiska uppgifter till eleverna baserat på lektionsinnehållet.",
        icon: <AssignmentIcon />,
      },
    ],
  },

  {
    showFor: ["teacher"],
    title: "Generera PowerPoints",
    altTitle: "Generera PowerPoint med AI",
    url: "powerpoint",
    titleSEO: "Generera PowerPoints med AI",
    description:
      "Generera PowerPoints med AI utifrån valfritt underlag med tillhörande bilder.",
    descriptionSEO:
      "Generera PowerPoints med AI utifrån valfritt underlag med tillhörande bilder.",
    descriptionLonger:
      "Generera PowerPoints med AI utifrån valfritt underlag med tillhörande bilder.",
    aboutText: "",

    icon: "<ChatIcon />",

    img: {
      light: "/img/generera powerpoints 3.png",
      dark: "/img/generera powerpoints 3.png",
    },

    heroImage: {
      light: "/img/flerval.png",
      dark: "/img/fraga-ai-hero-video-l.mp4",
    },
    details: [
      {
        text: "Valfritt underlag: Generera din PowerPoint baserat på ämne från Skolverkets kursplan, en artikel från SO-rummet eller baserat på helt egna instruktioner.",
        icon: <PowerPointIcon />,
      },
      {
        text: "Generera eller välj bilder till varje slide: Generera engagerande bilder till presentationen, ladda upp en av dina egna eller välj en från ditt personliga bildgalleri.",
        icon: <GenerateIcon />,
      },
      {
        text: "Redigera och spara: Du har frihet att redigera, ta bort och lägga till slides i presentationen utifrån dina personliga behov. Du kan även spara den i din privata lektionsbank.",
        icon: <EditIcon />,
      },
      {
        text: "Dela med elever & lärare: Dela med elever eller en kollega, eller spara den till din hårddisk.",
        icon: <ShareIcon />,
      },
    ],
  },

  {
    showFor: ["teacher"],
    title: "Fråga AI — ChatGPT för lärare",
    titleSEO: "Fråga AI — ChatGPT för lärare",
    description: "ChatGPT helt anpassad för lärare med fördefinierade prompts.",
    descriptionSEO:
      "Fråga AI för att få djupgående svar och förklaringar på alla dina frågor. Få hjälp med koncept, analogier och problemlösning inom alla ämnesområden.",
    descriptionLonger:
      "Utforska ett obegränsat område av kunskap genom att fråga AI. Få förklaringar, analogier och liknelser som gör komplexa koncept lättförståeliga. Lägg till egna prompts för att effektivisera din inlärning.",
    aboutText:
      'Fråga AI är utformad för att underlätta hur du söker information och förståelse. Genom att utnyttja avancerad AI-teknologi kan du få djupgående, anpassade svar på praktiskt taget vilken fråga som helst, oavsett komplexitet eller ämnesområde.\n\nDenna funktion erbjuder mer än bara snabba svar. AI:n kan förklara komplexa koncept, använda enkla analogier och liknelser för att förtydliga svåra ämnen, och anpassa förklaringarna efter din kompetensnivå. Du kan ställa följdfrågor för att fördjupa din förståelse, be om förtydliganden, eller utforska relaterade ämnen.\n\nEn unik aspekt av Fråga AI är möjligheten att spara och organisera dina konversationer. Detta gör det möjligt för dig att bygga en personlig kunskapsbas över tid, organiserad efter de ämnen du utforskat.  Du kan enkelt markera viktiga svar, kopiera meddelanden för framtida referens, och till och med lägga till dina egna prompts för att snabbt kunna återkomma till specifika frågeställningar.\n\n Dessutom kan man omvandla sina konversationer till interaktiva quiz, så efter att ha diskuterat ett ämne, som till exempel "jämställdheten utveckling under 1900-talet", kan du generera ett quiz baserat på konversationen. Detta hjälper dig att testa din förståelse, förstärka din inlärning och identifiera områden där man kan behöva mer fördjupning. Det är ett kraftfullt verktyg för att konsolidera ens kunskap och göra lärandet mer engagerande. \n\n Oavsett om du är student som söker hjälp med läxor, en lärare som behöver inspiration till lektionsplaneringar, en professionell som vill fördjupa din kunskap inom ditt fält, eller bara en nyfiken person som vill lära sig mer om världen, är Fråga AI din personliga, alltid tillgängliga källa till kunskap och insikt.',

    icon: "<ChatIcon />",
    // video: {
    //   light: "/img/fai-l.mp4",
    //   dark: "/img/fai-d.mp4",
    // },
    img: {
      light: "/img/fraga-ai-larare.png",
      dark: "/img/fraga-ai-larare.png",
    },

    heroImage: {
      light: "/img/flerval.png",
      dark: "/img/fraga-ai-hero-video-l.mp4",
    },
    details: [
      {
        text: "Fördefinierade prompts: Använd 'Förklara för mig', 'Sammanfatta det viktigaste' och 'Jämför och förklara skillnader' för att snabbt få ett svar i önskat längd, komplexitetsnivå och format.",
        icon: <PsychologyIcon />,
      },

      {
        text: "Skapa egna prompts: Skapa och spara skräddarsydda prompts för att snabbt få hjälp med återkommande frågor eller specifika undervisningsbehov.",

        icon: <SaveIcon />,
      },
      {
        text: "Välj mellan 50 olika språk: Ställ in så att den kommunicerar med dig på det språk du föredrar.",
        icon: <LanguageIcon />,
      },
      {
        text: "Spara konversationer: Tillgång till ditt egna arkiv med kategoriserade konversationer för enkel åtkomst.",

        icon: <SaveIcon />,
      },

      {
        text: "Generera quiz: Omvandla dina konversationer till interaktiva quiz för att testa din förståelse i det ni talat om.",
        icon: <QuizIcon />,
        showInFeaturePage: true,
      },

      {
        text: "Ämnesspecifik expertis: Få tillgång till djup kunskap inom en mängd olika ämnen, från naturvetenskap till humaniora.",
        icon: <SchoolIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Interaktiv problemlösning: Arbeta steg för steg genom komplexa problem med AI-assistans för djupare förståelse.",
        icon: <BuildIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Konversationshistorik: Spara, organisera och återbesök tidigare chattar för att bygga en personlig kunskapsbas över tid.",
        icon: <HistoryIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Källhänvisningar: När det är möjligt, ger AI-modellen referenser till relevanta källor för ytterligare läsning och verifiering.",
        icon: <MenuBookIcon />,
        showInFeaturePage: true,
      },
    ],
    pros: [
      {
        text: "Tillgång till omfattande kunskap dygnet runt",
        icon: <AccessTimeIcon />,
      },
      {
        text: "Anpassade förklaringar för olika kunskapsnivåer",
        icon: <TuneIcon />,
      },
      {
        text: "Möjlighet att bygga en personlig kunskapsbas över tid",
        icon: <TrendingUpIcon />,
      },
    ],
    steps: [
      {
        title: "Börja med att fråga AI",
        description:
          "Börja med att ställa vilken fråga som helst till vår AI-modell inom vilket ämnesområde som helst.",
      },
      {
        title: "Få djupgående svar",
        description:
          "AI:n ger dig ett omfattande och anpassat svar, med möjlighet att be om förtydliganden eller följdfrågor.",
      },
      {
        title: "Utforska och lär",
        description:
          "Fortsätt konversationen för att fördjupa din förståelse, be om exempel eller relaterad information.",
      },
      {
        title: "Spara och organisera",
        description:
          "Markera viktiga svar, spara hela konversationer och organisera din inlärning för framtida referens.",
      },
    ],
    typeAnimationSequence: [
      "Få svar på alla dina frågor ",
      1000,
      "Utforska komplexa ämnen med AI ",
      1000,
      "Förstå svåra koncept genom enkla analogier ",
      1000,
      "Bygg din personliga kunskapsbas ",
      1000,
      "Lös problem steg för steg med AI-hjälp ",
      1000,
      "Lär dig på ditt eget språk ",
      1000,
      "Få djupgående kunskap inom alla ämnen ",
      1000,
    ],
  },

  {
    showFor: ["student"],
    title: "Generera quiz med AI",
    //description: "Generera läxförhör baserat på ditt studiematerial.",
    titleSEO: "Generera prov & quiz med AI",
    descriptionSEO:
      "Generera skräddarsydda quiz med AI för att testa och förstärka din kunskap. Perfekt för läxförhör. Anpassa frågor, följ dina framsteg och förbättra din inlärningsupplevelse.",
    descriptionLonger:
      "Generera skräddarsydda quiz för att testa och förstärka din kunskap med hjälp av AI. Anpassa frågetyper, svårighetsgrad och innehåll för att matcha dina inlärningsbehov, och följ dina framsteg över tid.",
    aboutText:
      'Vår quiz-funktion är utformad för att revolutionera hur du testar och förstärker din kunskap. Med hjälp av avancerad AI-teknologi kan du generera skräddarsydda quiz baserade på vilket ämne eller material som helst. Detta hjälper dig att effektivt repetera och befästa kunskap på ett sätt som är anpassat efter dina behov.\n\nDu kan ladda upp dina egna dokument eller använda YouTube-videor som grund för quiz-frågorna, vilket gör att du kan förvandla dina studie- eller undervisningsmaterial till interaktiva övningar. Med möjligheten att anpassa frågetyper, svårighetsgrad och antal frågor får du full kontroll över din inlärningsprocess.\n\nGenom att använda våra AI-genererade quiz kan du förbättra din förståelse för ämnet, identifiera områden som behöver ytterligare arbete och följa dina framsteg över tid. Detta gör inlärningen mer engagerande och effektiv, oavsett om du är student, lärare eller självlärande.\n\n Dessutom erbjuder vår quiz-funktion en unik AI-assistansfunktion som tar din inlärningsupplevelse till nästa nivå. När som helst under quizet kan du klicka på "Fråga AI" för att få djupgående, personligt anpassade förklaringar baserade på din nuvarande kunskapsnivå. Du kan be om förtydliganden, analogier eller ytterligare kontext för att bättre förstå frågorna och svaren. Denna interaktiva funktion fungerar som en personlig tutor, redo att hjälpa dig när du behöver det mest, vilket säkerställer att du inte bara memorerar information utan verkligen förstår och kan tillämpa den kunskap du förvärvar.',
    icon: <QuizIcon />,
    //video: { light: "/img/q-l.mp4", dark: "/img/q-d.mp4" },

    img: {
      light: "/img/flerval.png",
      dark: "/img/flerval.png",
    },

    heroImage: {
      light: "/img/quiz-hero-video-l.mp4",
      dark: "/img/quiz-hero-video-l.mp4",
    },
    details: [
      {
        text: "Genererar frågor baserat på valfritt underlag: Generera prov/quiz baserat på ämne från Skolverkets kursplan, uppladdat dokument, artikel från SO-rummet eller helt egna instruktioner.",
        icon: <FactCheckIcon />,
      },
      {
        text: "Välj mellan 4 frågetyper: Prov där du skriver in ditt eget svar, flervalsfrågor med fördefinierade alternativ, sant eller falskt-frågor samt fyll-i-luckan.",
        icon: <QuestionAnswerIcon />,
      },

      {
        text: "Redigera och anpassa: Redigera frågorna, svarsalternativen och ledtrådarna utifrån dina behov.",
        icon: <MenuBookIcon />,
      },
      {
        text: "Interaktivt prov: Du kan när som helst gå in i det interaktiva läget där du antingen svarar på alternativ eller skriver in ett resonserande svar sjålv, väljer du att spara kan du närsomhelst gå tillbaka och öva igen, eller redigera det för att anpassa det ytterligare.",
        icon: <ShareIcon />,
      },

      {
        text: "Läxförhör: Perfekt för elever som vill testa sin kunskap inför prov. Välj mellan flervalsfrågor, sant/falskt eller fyll-i-luckan för att skapa varierade och effektiva läxförhör.",
        icon: <SchoolIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Framstegsövervakning: Följ dina resultat över tid för att identifiera styrkor och svagheter, vilket hjälper dig att fokusera på områden som behöver förbättras.",
        icon: <TrendingUpIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Spara och organisera: Lagra dina quiz och resultat på ett strukturerat sätt för enkel åtkomst och uppföljning av din inlärningsprogression.",
        icon: <FolderIcon />,
        showInFeaturePage: true,
      },

      {
        text: "Fråga AI: Klicka när som helst på 'Fråga AI' för att få detaljerade förklaringar anpassade efter din kunskapsnivå, be om analogier eller få ytterligare kontext för att bättre förstå frågorna och fördjupa ditt lärande.",
        icon: <LiveHelpIcon />,
        showInFeaturePage: true,
      },

      {
        text: "Ta del av andra användares quiz: Utforska och använd quiz skapade av andra användare för att få tillgång till ett brett utbud av ämnen och perspektiv, vilket berikar din inlärningsupplevelse och ger möjlighet att testa din kunskap inom nya områden.",
        icon: <PeopleIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Ledtrådar: Klicka på 'Ledtråd'-knappen när du behöver lite extra hjälp. Få smarta och relevanta ledtrådar som guidar dig mot rätt svar utan att avslöja det helt, så inlärningsprocessen blir mer engagerande.",
        icon: <EmojiObjectsIcon />,
        showInFeaturePage: true,
      },
    ],
    pros: [
      {
        text: "Effektiviserar inlärningsprocessen med interaktiva quiz",
        icon: <SpeedIcon />,
      },
      {
        text: "Anpassad inlärning efter dina specifika behov",
        icon: <AccessibilityNewIcon />,
      },
      {
        text: "Förbättrar kunskapsretention och förståelse",
        icon: <EmojiObjectsIcon />,
      },
    ],
    steps: [
      {
        title: "Välj ämne eller ladda upp material",
        description:
          "Börja med att ange ett ämne, ladda upp ett dokument eller ange en YouTube-länk.",
      },
      {
        title: "Generera quiz med AI",
        description:
          "Anpassa dina inställningar såsom frågetyper, svårighetsgrad, AI-modell och antal frågor, och låt AI generera quizet.",
      },
      {
        title: "Genomför quizet och följ dina framsteg",
        description:
          "Svara på frågorna, få omedelbar feedback och se dina resultat för att identifiera områden för förbättring.",
      },
    ],
    typeAnimationSequence: [
      "Generera skräddarsydda quiz med AI ",
      1000,
      "Anpassa frågetyper och svårighetsgrad ",
      1000,
      "Förvandla dina dokument till interaktiva quiz ",
      1000,
      "Förbättra din kunskapsretention ",
      1000,
      "Följ dina framsteg över tid ",
      1000,
      "Gör inlärningen roligare och mer effektiv ",
      1000,
      "Få AI-assistans när du behöver det ",
      1000,
    ],
  },

  {
    title: "AI-Bibeln",
    titleSEO: "AI-Bibeln",
    url: "bibeln",
    description:
      "Chatta med Bibeln genom vår specialtränade AI-modell som via semantisk sökning identifierar de mest relevanta textavsnitten från originalkällan, och ger dig svar som är direkt förankrade i bokens faktiska innehåll.",
    descriptionSEO:
      "Chatta med Bibeln genom vår specialtränade AI-modell som via semantisk sökning identifierar de mest relevanta textavsnitten från originalkällan, och ger dig svar som är direkt förankrade i bokens faktiska innehåll.",
    descriptionLonger:
      "Chatta med Bibeln genom vår specialtränade AI-modell som via semantisk sökning identifierar de mest relevanta textavsnitten från originalkällan, och ger dig svar som är direkt förankrade i bokens faktiska innehåll.",
    aboutText: "",
  },

  {
    title: "AI-assistenter",
    titleSEO: "AI-assistenter",
    url: "assistenter",
    description:
      "Skapa egna AI-assistenter, utforska vårt bibliotek av assistenter för olika ämnen och språk. Simulera rollspel för att lära sig språk enklare.",
    descriptionSEO:
      "Skapa egna AI-assistenter, utforska vårt bibliotek av assistenter för olika ämnen och språk. Simulera rollspel för att lära sig språk enklare.",
    descriptionLonger:
      "Skapa egna AI-assistenter, utforska vårt bibliotek av assistenter för olika ämnen och språk. Simulera rollspel för att lära sig språk enklare.",
    aboutText: "",
  },

  {
    title: "Generera bilder med AI",
    titleSEO: "Generera bilder med AI",
    url: "bilder",
    description:
      "Generera bilder med AI, få tillgång till ditt eget arkiv samt en delad bildbank där du kan filtrera och ladda ned valfria bilder.",
    descriptionSEO:
      "Generera bilder med AI, få tillgång till ditt eget arkiv samt en delad bildbank där du kan filtrera och ladda ned valfria bilder.",
    descriptionLonger:
      "Generera bilder med AI, få tillgång till ditt eget arkiv samt en delad bildbank där du kan filtrera och ladda ned valfria bilder.",
    aboutText: "",
  },

  {
    title: "Hjälpmedel",
    titleSEO: "Hjälpmedel",
    url: "hjalpmedel",
    description:
      "Utforska våra andra hjälpmedel så som bildanalys, generera powerpoint, skapa begreppslista och mycket mer.",
    descriptionSEO:
      "Utforska våra andra hjälpmedel så som bildanalys, generera powerpoint, skapa begreppslista och mycket mer.",
    descriptionLonger:
      "Utforska våra andra hjälpmedel så som bildanalys, generera powerpoint, skapa begreppslista och mycket mer.",
    aboutText: "",
  },

  {
    title: "Generera lektionsplaneringar",
    altTitle: "Generera lektionsplanering med AI",
    url: "lektionsplanering",
    titleSEO: "Generera lektionsplanering med AI",
    description:
      "Generera lektionsplanering med AI. Spara i din egen lektionsbank, dela med elever eller kollegor, eller skriv ut direkt.",
    descriptionSEO:
      "Generera lektionsplanering med AI. Spara i din egen lektionsbank, dela med elever eller kollegor, eller skriv ut direkt.",
    descriptionLonger:
      "Generera lektionsplanering med AI. Spara i din egen lektionsbank, dela med elever eller kollegor, eller skriv ut direkt.",
    aboutText: "",
  },

  {
    showFor: ["student"],
    title: "Generera flashcards med AI",
    titleSEO: "Generera  flashcards med AI",
    //description: "Interaktiva flashcards baserat på valfritt underlag",
    descriptionSEO:
      "Skapa anpassade flashcards med AI för effektiv inlärning. Generera flashcards från dokument, videor eller valfritt ämne för att förbättra din studieteknik.",
    descriptionLonger:
      "Generera skräddarsydda flashcards baserat på ditt studiematerial med hjälp av AI. Skapa flashcards från dokument, YouTube-videor eller valfritt ämne för att effektivisera din inlärning och förbättra minnesbehållning.",
    aboutText:
      'Genom att använda avancerad AI-teknologi kan du snabbt och enkelt skapa effektiva flashcards från valfritt studiematerial eller ämne.\n\nDu kan ladda upp dina egna dokument, använda YouTube-videor som källa, skriva in en valfri URL, eller helt enkelt ange ett ämne för att generera relevanta flashcards. Detta gör det möjligt att omvandla all typ av inlärningsmaterial till interaktiva flashcards som hjälper dig att bättre förstå och komma ihåg viktiga koncept.\n\nMed möjligheten att anpassa dina flashcards och implementera principen om distribuerad repetition, optimerar du din inlärningsprocess och förbättrar din långsiktiga minnesbehållning. Detta gör flashcards-funktionen till ett ovärderligt verktyg för studenter, yrkesverksamma och andra som vill effektivisera sin kunskapsinhämtning.\n\nDessutom får du tillgång till en unik Fråga AI-funktion som fördjupar din inlärning där du kan ställa frågor för att förstå mer om ämnet i fråga, så när du går igenom dina flashcards kan du när som helst klicka på "Fråga AI" för att få djupgående, personligt anpassade förklaringar. Du kan be om förtydliganden, exempel eller ytterligare kontext för att bättre förstå informationen på kortet. Detta interaktiva element fungerar som en personlig lärare, redo att hjälpa dig fördjupa din förståelse och koppla samman olika koncept, vilket säkerställer att du inte bara memorerar fakta utan verkligen förstår och kan tillämpa kunskapen.',
    icon: <ViewAgendaIcon />,
    //video: { light: "/img/f-l.mp4", dark: "/img/f-d.mp4" },

    img: {
      light: "/img/flash.png",
      dark: "/img/flash.png",
    },

    heroImage: {
      light: "/img/flashcards-hero-video-l.mp4",
      dark: "/img/flashcards-hero-video-l.mp4",
    },
    details: [
      {
        text: "Genererar flashcards baserat på valfritt underlag: Generera flashcards baserat på egna instruktioner, uppladdat dokument, ämne från Skolverkets kursplan eller artikel från SO-rummet.",
        icon: <FactCheckIcon />,
      },

      {
        text: "Redigera och anpassa: Redigera flashcards utifrån dina specifika behov, möjlighet att lägga till bilder till fram- och baksida föra att främja visuell inlärning.",
        icon: <MenuBookIcon />,
      },

      {
        text: "Välj mellan 50 olika språk: Generera flashcards på över 50 olika språk.",
        icon: <LanguageIcon />,
      },
      {
        text: "Distribuerad repetition: Vi använder principen om distribuerad repetition för att förbättra  minnesbehållningen och optimera din inlärningsprocess.",
        icon: <TrendingUpIcon />,
      },

      {
        text: "Anpassningsbara flashcards: Skräddarsy dina flashcards genom att redigera framsida och baksida, lägga till bilder eller ändra svårighetsgrad för att matcha dina inlärningsbehov.",
        icon: <TuneIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Följ dina framsteg: Följ dina resultat och inlärningskurva över tid för att identifiera områden som behöver mer fokus och se din förbättring.",
        icon: <AssessmentIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Dela och samarbeta: Dela dina flashcards-samlingar med andra användare för att berika allas inlärningsupplevelse.",
        icon: <ShareIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Fråga AI: Använd 'Fråga AI'-funktionen när du går igenom dina flashcards för att få djupgående förklaringar, exempel eller ytterligare kontext anpassad efter din kunskapsnivå.",
        icon: <LiveHelpIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Ledtrådar: Be om AI-genererade ledtrådar innan du vänder på kortet för att göra upplevelsen med engagerande.",
        icon: <EmojiObjectsIcon />,
        showInFeaturePage: true,
      },
    ],
    pros: [
      {
        text: "Effektiviserar skapandet av studiematerial",
        icon: <SpeedIcon />,
      },
      {
        text: "Förbättrar minnesretention genom aktiv repetition",
        icon: <MemoryIcon />,
      },
      {
        text: "Anpassningsbar för olika inlärningsstilar och ämnen",
        icon: <TuneIcon />,
      },
    ],
    steps: [
      {
        title: "Välj källa eller ange ämne",
        description:
          "Börja med att välja en källa (dokument, video, URL) eller ange ett specifikt ämne för dina flashcards.",
      },
      {
        title: "Generera flashcards med AI",
        description:
          "Låt AI generera flashcards baserat på din input. Granska och anpassa korten efter behov.",
      },
      {
        title: "Studera och förbättra",
        description:
          "Använd dina flashcards regelbundet, följ dina framsteg och använd AI-assistans för djupare förståelse.",
      },
    ],
    typeAnimationSequence: [
      "Skapa anpassade flashcards med AI ",
      1000,
      "Generera kort från dokument eller videor ",
      1000,
      "Förbättra din minnesretention ",
      1000,
      "Studera effektivt var som helst ",
      1000,
      "Följ dina framsteg över tid ",
      1000,
      "Få AI-assistans för djupare förståelse ",
      1000,
      "Optimera din inlärning med flashcards ",
      1000,
    ],
  },

  {
    showFor: ["student"],
    title: "Låt AI betygsätta din text",
    description:
      "Få en rättvis bedömning av din text med hjälp av AI – utan påverkan av lärarens subjektiva åsikter.",
    icon: <InsertDriveFileIcon />,
    //video: { light: "/img/b-u-l.mp4", dark: "/img/b-u-d.mp4" },

    img: {
      light: "/img/omdome.png",
      dark: "/img/omdome.png",
    },

    customLink: "betygsatt-uppsatser-med-ai",
    details: [
      {
        text: "Ladda upp och bedöm texter: Använd AI för att analysera din uppsats genom att ladda upp ett Word-dokument eller klistra in din text direkt.",
        icon: <InsertDriveFileIcon />,
      },
      {
        text: "Anpassad feedback: Använd fördefinierade typer av bedömningsmatriser (förklarande, argumenterande, beskrivande, berättande m.fl.) beroende på typ av text. Eller skapa en egen matris.",
        icon: <AssessmentIcon />,
      },
      {
        text: "Standardiserad bedömning: Säkerställ att alla texter bedöms på samma sätt av AI för att uppnå rättvisa och objektiva resultat.",
        icon: <VerifiedUserIcon />,
      },
      {
        text: "Få detaljerad analys och förbättringsförslag: Efter bedömningen får du en detaljerad analys av din text med specifika tips för att förbättra den. ",
        icon: <EmojiObjectsIcon />,
      },
    ],
  },

  {
    showFor: ["student"],
    title: "Fråga AI",
    titleSEO: "Fråga AI - Få djupgående svar på alla dina frågor",
    description:
      "Få djupgående förklaringar på komplexa ämnen och svar på alla dina frågor.",
    descriptionSEO:
      "Fråga AI för att få djupgående svar och förklaringar på alla dina frågor. Få hjälp med koncept, analogier och problemlösning inom alla ämnesområden.",
    descriptionLonger:
      "Utforska ett obegränsat område av kunskap genom att fråga AI. Få förklaringar, analogier och liknelser som gör komplexa koncept lättförståeliga. Lägg till egna prompts för att effektivisera din inlärning.",
    aboutText:
      'Fråga AI är utformad för att underlätta hur du söker information och förståelse. Genom att utnyttja avancerad AI-teknologi kan du få djupgående, anpassade svar på praktiskt taget vilken fråga som helst, oavsett komplexitet eller ämnesområde.\n\nDenna funktion erbjuder mer än bara snabba svar. AI:n kan förklara komplexa koncept, använda enkla analogier och liknelser för att förtydliga svåra ämnen, och anpassa förklaringarna efter din kompetensnivå. Du kan ställa följdfrågor för att fördjupa din förståelse, be om förtydliganden, eller utforska relaterade ämnen.\n\nEn unik aspekt av Fråga AI är möjligheten att spara och organisera dina konversationer. Detta gör det möjligt för dig att bygga en personlig kunskapsbas över tid, organiserad efter de ämnen du utforskat.  Du kan enkelt markera viktiga svar, kopiera meddelanden för framtida referens, och till och med lägga till dina egna prompts för att snabbt kunna återkomma till specifika frågeställningar.\n\n Dessutom kan man omvandla sina konversationer till interaktiva quiz, så efter att ha diskuterat ett ämne, som till exempel "jämställdheten utveckling under 1900-talet", kan du generera ett quiz baserat på konversationen. Detta hjälper dig att testa din förståelse, förstärka din inlärning och identifiera områden där man kan behöva mer fördjupning. Det är ett kraftfullt verktyg för att konsolidera ens kunskap och göra lärandet mer engagerande. \n\n Oavsett om du är student som söker hjälp med läxor, en lärare som behöver inspiration till lektionsplaneringar, en professionell som vill fördjupa din kunskap inom ditt fält, eller bara en nyfiken person som vill lära sig mer om världen, är Fråga AI din personliga, alltid tillgängliga källa till kunskap och insikt.',

    icon: "<ChatIcon />",
    // video: {
    //   light: "/img/fai-l.mp4",
    //   dark: "/img/fai-d.mp4",
    // },
    img: {
      light: "/img/fraga.png",
      dark: "/img/fraga.png",
    },

    heroImage: {
      light: "/img/flerval.png",
      dark: "/img/fraga-ai-hero-video-l.mp4",
    },
    details: [
      {
        text: "Fördefinierade prompts: Använd 'Förklara för mig', 'Sammanfatta det viktigaste', 'Jämför och förklara skillnader' samt 'Starta en debatt/rollspel' för att snabbt få ett svar i önskat längd, komplexitetsnivå och format.",
        icon: <PsychologyIcon />,
      },

      {
        text: "Skapa egna prompts: Skapa och spara skräddarsydda prompts för att snabbt få hjälp med återkommande frågor eller specifika format.",

        icon: <SaveIcon />,
      },
      {
        text: "Välj mellan 50 olika språk: Ställ in så att den kommunicerar med dig på det språk du föredrar.",
        icon: <LanguageIcon />,
      },
      {
        text: "Spara konversationer: Tillgång till ditt egna arkiv med kategoriserade konversationer för enkel åtkomst.",

        icon: <SaveIcon />,
      },
      {
        text: "Generera quiz: Omvandla dina konversationer till interaktiva quiz för att testa din förståelse i det ni talat om.",
        icon: <QuizIcon />,
        showInFeaturePage: true,
      },

      {
        text: "Ämnesspecifik expertis: Få tillgång till djup kunskap inom en mängd olika ämnen, från naturvetenskap till humaniora.",
        icon: <SchoolIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Interaktiv problemlösning: Arbeta steg för steg genom komplexa problem med AI-assistans för djupare förståelse.",
        icon: <BuildIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Konversationshistorik: Spara, organisera och återbesök tidigare chattar för att bygga en personlig kunskapsbas över tid.",
        icon: <HistoryIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Källhänvisningar: När det är möjligt, ger AI-modellen referenser till relevanta källor för ytterligare läsning och verifiering.",
        icon: <MenuBookIcon />,
        showInFeaturePage: true,
      },
    ],
    pros: [
      {
        text: "Tillgång till omfattande kunskap dygnet runt",
        icon: <AccessTimeIcon />,
      },
      {
        text: "Anpassade förklaringar för olika kunskapsnivåer",
        icon: <TuneIcon />,
      },
      {
        text: "Möjlighet att bygga en personlig kunskapsbas över tid",
        icon: <TrendingUpIcon />,
      },
    ],
    steps: [
      {
        title: "Börja med att fråga AI",
        description:
          "Börja med att ställa vilken fråga som helst till vår AI-modell inom vilket ämnesområde som helst.",
      },
      {
        title: "Få djupgående svar",
        description:
          "AI:n ger dig ett omfattande och anpassat svar, med möjlighet att be om förtydliganden eller följdfrågor.",
      },
      {
        title: "Utforska och lär",
        description:
          "Fortsätt konversationen för att fördjupa din förståelse, be om exempel eller relaterad information.",
      },
      {
        title: "Spara och organisera",
        description:
          "Markera viktiga svar, spara hela konversationer och organisera din inlärning för framtida referens.",
      },
    ],
    typeAnimationSequence: [
      "Få svar på alla dina frågor ",
      1000,
      "Utforska komplexa ämnen med AI ",
      1000,
      "Förstå svåra koncept genom enkla analogier ",
      1000,
      "Bygg din personliga kunskapsbas ",
      1000,
      "Lös problem steg för steg med AI-hjälp ",
      1000,
      "Lär dig på ditt eget språk ",
      1000,
      "Få djupgående kunskap inom alla ämnen ",
      1000,
    ],
  },

  {
    title: "Lär dig språk med AI",
    titleSEO: "Lär dig språk med AI",
    description:
      "Upptäck ett revolutionerande sätt att lära dig språk genom interaktiva samtal och skräddarsydda övningar med hjälp av AI.",
    descriptionSEO:
      "Upptäck ett revolutionerande sätt att lära dig språk med AI. Interaktiva samtal, skräddarsydda övningar och personlig feedback för en effektiv språkinlärning.",
    descriptionLonger:
      "Upptäck ett revolutionerande sätt att lära dig språk genom interaktiva samtal och skräddarsydda övningar med hjälp av AI. Få personlig feedback, anpassade lektioner och förbättra dina språkkunskaper snabbare än någonsin.",
    aboutText:
      'Denna banbrytande aspekt av Studera.ai är utformad för att omdefiniera sättet du lär dig nya språk. Genom att utnyttja den senaste AI-teknologin får du en personlig och interaktiv inlärningsupplevelse som anpassar sig efter dina individuella behov och mål.\n\nMed AI-assisterade interaktiva dialoger kan du öva på språket i realistiska scenarier, vilket förbättrar din kommunikationsförmåga och självförtroende. Skräddarsydda grammatik- och vokabulärövningar hjälper dig att stärka dina språkliga färdigheter, medan kontinuerlig feedback från AI gör att du kan fokusera på områden som behöver förbättras.\n\nEn unik funktion är möjligheten att enkelt dela dina konversationer med din lärare genom en genererad länk, vilket möjliggör personlig feedback och vägledning. Du kan också spara viktiga meddelanden för framtida referens och repetition.\n\n Vidare finns möjligheten att generera språkspecifika quiz baserade på dina konversationer med AI-läraren. Efter att ha övat på en aspekt av språket som till exempel "preteritum" på spanska, kan du skapa ett interaktivt quiz för att testa din förståelse och användning av nya ord och fraser. Detta hjälper dig att befästa din kunskap, identifiera områden som behöver mer övning, och gör hela inlärningsprocessen mer engagerande och effektiv. \n\n Dessutom kan du anpassa AI-lärarens instruktioner för att skräddarsy din inlärningsupplevelse. Du kan till exempel be AI:n att alltid använda de enklaste möjliga orden eller fokusera på specifika grammatiska aspekter.\n\nAtt lära sig språk med AI är inte bara en ny metod – det är en revolution inom språkinlärning som gör processen mer engagerande, effektiv och anpassad än någonsin tidigare.',
    icon: <LanguageIcon />,
    //video: { light: "/img/lang-l.mp4", dark: "/img/lang-d.mp4" },

    img: {
      light: "/img/sprak.png",
      dark: "/img/sprak.png",
    },

    heroImage: {
      light: "/img/lar-dig-sprak-hero-video-l.mp4",
      dark: "/img/lar-dig-sprak-hero-video-l.mp4",
    },
    details: [
      {
        text: "Interaktiva dialoger: Delta i simulerade konversationer som speglar verkliga situationer, vilket hjälper dig att bli mer flytande och självsäker i ditt valda språk.",
        icon: <RecordVoiceOverIcon />,
      },
      {
        text: "Grammatikövningar: Arbeta med skräddarsydda grammatikövningar för att förbättra din förståelse av språkliga strukturer och öka din språkliga precision.",
        icon: <GTranslateIcon />,
      },
      // {
      //   text: "Vokabulärträning: Utöka ditt ordförråd genom att lära dig nya ord och fraser i kontext, vilket underlättar memorering och korrekt användning.",
      //   icon: <MenuBookIcon />,
      // },
      {
        text: "Nivåbedömning: Låt AI utvärdera din nuvarande språknivå och ge rekommendationer för vidare utveckling, så att du kan fokusera på områden som behöver förbättras.",
        icon: <GradeIcon />,
      },
      {
        text: "Personlig feedback: Få kontinuerlig och anpassad feedback från AI, vilket hjälper dig att identifiera styrkor och områden för förbättring.",
        icon: <EmojiObjectsIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Anpassad inlärningstakt: Lär dig i din egen takt med material och övningar som anpassar sig efter dina framsteg och inlärningsstil.",
        icon: <SpeedIcon />,
        showInFeaturePage: true,
      },

      {
        text: "Dela konversationer: Dela enkelt dina konversationer med din lärare genom en genererad länk för personlig feedback och vägledning.",
        icon: <ShareIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Spara meddelanden: Spara konversationer och meddelanden för framtida referens och uppföljning.",
        icon: <SaveIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Redigera AI-instruktioner: Anpassa din AI-lärares beteende genom att justera instruktionerna, t.ex. att alltid använda de enklast möjliga orden för att matcha din inlärningsstil.",
        icon: <SettingsIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Språkspecifika quiz: Generera interaktiva quiz baserade på dina konversationer för att testa och förstärka din förståelse av nya ord, fraser och grammatiska koncept.",
        icon: <QuizIcon />,
        showInFeaturePage: true,
      },
    ],
    pros: [
      {
        text: "Revolutionerar språkinlärning med AI",
        icon: <AutoFixHighIcon />,
      },
      {
        text: "Anpassad och personlig inlärningsupplevelse",
        icon: <AccessibilityNewIcon />,
      },
      {
        text: "Förbättrar kommunikativa färdigheter genom interaktiva dialoger",
        icon: <ChatIcon />,
      },
    ],
    steps: [
      {
        title: "Välj språklärare",
        description:
          "Börja med att välja den språklärare som passar dig från vårt breda urval av AI-lärare.",
      },
      {
        title: "Delta i interaktiva lektioner",
        description:
          "Engagera dig i AI-assisterade lektioner och övningar som anpassar sig efter dina behov.",
      },
      {
        title: "Utvärdera din nivå",
        description:
          "Efter några konversationer kan AI utvärdera din nivå och anpassa pedagogiken för att effektivisera ditt lärande.",
      },
      {
        title: "Dela med din lärare",
        description:
          "Dela dina konversationer med din lärare genom att generera en delbar länk, vilket underlättar feedback och uppföljning.",
      },
    ],
    typeAnimationSequence: [
      "Upptäck ett nytt sätt att lära dig språk ",
      1000,
      "Anpassade lektioner med AI ",
      1000,
      "Interaktiva dialoger för bättre flyt ",
      1000,
      "Personlig feedback i realtid ",
      1000,
      "Förbättra dina språkkunskaper snabbare ",
      1000,
      "Revolutionera din språkinlärning idag ",
      1000,
    ],
  },

  {
    title: "Skapa kurser med AI",
    titleSEO: "Skapa kurser med AI",
    description: "Skapa skräddarsydda kurser med AI.",
    descriptionSEO:
      "Skapa skräddarsydda kurser med AI. Generera quiz, flashcards och podcasts för att öva på innehållet. Studera i din egen takt.",
    descriptionLonger:
      "Skapa skräddarsydda kurser med AI. Generera quiz, flashcards och podcasts för att öva på innehållet. Studera i din egen takt.",
    aboutText:
      "Denna funktion är designad för att revolutionera hur du lär dig. Genom att använda kraften i AI kan du enkelt generera skräddarsydda kurser baserat på dina inlärningsbehov. AI hjälper dig att bryta ner komplexa ämnen i hanterbara delkurser och kapitel, vilket gör att du kan fokusera på det som verkligen spelar roll – i din egen takt.\n\nMed interaktiva verktyg som automatiskt skapade quiz, flashcards och till och med podcasts, kan du förstärka din inlärning på flera sätt. Fråga AI-funktionen låter dig ställa frågor om specifika kapitel och ger djupare förståelse med förtydliganden och exempel, precis när du behöver dem.\n\n Istället för att spendera timmar på att strukturera innehåll eller skapa övningsmaterial, gör AI det åt dig på några sekunder. Du kan enkelt markera lektioner som klara och följa dina framsteg, vilket ger dig full kontroll över din inlärningsresa.\n\nKort sagt, att skapa kurser med AI gör det enklare och snabbare att lära sig – helt på dina villkor.",
    icon: <SchoolIcon />,
    //video: { light: "/img/kurser-l.mp4", dark: "/img/kurser-d.mp4" },

    img: {
      light: "/img/kurser.png",
      dark: "/img/kurser.png",
    },

    heroImage: {
      light: "/img/kurser-hero-image-l.png",
      dark: "/img/kurser-hero-image-l.png",
    },
    details: [
      {
        text: "AI-drivna kurser: Skapa omfattande kurser med hjälp av AI, inklusive delkurser och kapitel, anpassade efter dina inlärningsbehov och mål.",
        icon: <AutoFixHighIcon />,
      },
      {
        text: "Interaktiva lektioner: Gå igenom lektioner i din egen takt, med möjlighet att generera quiz och flashcards för varje lektion för att förstärka ditt lärande.",
        icon: <MenuBookIcon />,
      },
      {
        text: "AI-assisterad fördjupning: Chatta med en AI-lärare om specifika kapitel för att få förtydliganden, exempel och djupare insikter i ämnet.",
        icon: <ChatIcon />,
      },
      {
        text: "Framstegsövervakning: Markera lektioner som slutförda och följ din progression genom kursen, vilket ger dig en tydlig överblick över din inlärningsresa.",
        icon: <CheckCircleOutlineIcon />,
      },
      {
        text: "Generera podcast: Föredrar du podcast framför att läsa så kan du generera podcast med AI baserat på kursinnehållet.",
        icon: <PodcastsIcon />,
        showInFeaturePage: true,
      },

      {
        text: "Exportera kursen: Exportera valfri kurs till PDF- eller Word-dokument om du föredrar det.",
        icon: <FileOpenIcon />,
        showInFeaturePage: true,
      },
    ],
    pros: [
      {
        text: "X",
        icon: <AutoFixHighIcon />,
      },
    ],
    steps: [
      {
        title: "Skriv in valfritt ämne",
        description: "Skriv in vilket ämne som helst, brett eller nischat.",
        image: "/img/kurser-steg-1-l.png",
      },
      {
        title: "Delkurser genereras",
        description:
          "Delkurser med kapitel skapas som du kan gå igenom i egen takt.",
        image: "/img/kurser-steg-2-l.png",
      },
      {
        title: "Öva på innehållet",
        description:
          "Fråga AI eller generera quiz, flashcards eller podcast baserat på innehållet.",
        image: "/img/kurser-steg-3-l.png",
      },
    ],
    typeAnimationSequence: [
      "Skapa skräddarsydda kurser ",
      1000,
      "Chatta med AI när du har frågor ",
      1000,
      "Öva i din egen takt ",
      1000,
      "Generera quiz och flashcards på kursinnehållet",
      1000,
      "Generera podcast baserat på innehållet",
      1000,
      "Följ dina framsteg ",
      1000,
      "Exportera din kurs ",
      1000,
    ],
  },

  {
    showFor: ["teacher", "student"],
    title: "Textlabbet",
    url: "textlabbet",
    titleSEO: "Textlabbet - AI-driven textanalys och förbättring",
    description: "Bearbeta dina texter med AI.",
    descriptionSEO:
      "Använd AI för att analysera, förbättra och omforma dina texter. Få djupgående textanalys, omstrukturering och redigering med Textlabbet.",
    descriptionLonger:
      "Använd Textlabbet för att förvandla och förbättra dina texter med hjälp av AI. Sammanfatta långa texter, omstrukturera innehåll, rätta grammatiska fel och optimera språket för att uppnå professionell kvalitet. Upptäck ett brett utbud av funktioner för att anpassa dina texter efter dina behov.",
    aboutText:
      "Textlabbet är designat för att hjälpa dig att förvandla och förbättra dina texter med hjälp av AI. Genom att utnyttja avancerad naturlig språkbehandling och maskininlärning, erbjuder Textlabbet en rad sofistikerade verktyg för textanalys, omstrukturering och förbättring.\n\nMed Textlabbet kan du snabbt och enkelt analysera långa texter, få konstruktiv kritik på ditt skrivande, och omforma ditt innehåll för bättre läsbarhet och engagemang. Du kan även använda det för att snabbt sammanfatta längre texter, till exempel i form av en koncis punktlista, faktakolla information du är osäker på, eller beräkna ordfrekvens för djupare språkanalys.\n\nVare sig du är student, professionell skribent, eller någon som bara vill förbättra sin skrivförmåga, ger Textlabbet dig möjligheten att ta ditt skrivande till nästa nivå.\n\nFrån grundläggande funktioner som stavningskontroll och grammatikkorrigering till mer avancerade verktyg som stilanalys och innehållsomstrukturering, är Textlabbet utformat för att möta behoven hos skribenter på alla nivåer. Det hjälper dig inte bara att korrigera fel, utan också att utveckla din egen unika röst och stil.\n\nMed möjligheten att spara och organisera dina redigerade texter direkt på plattformen, gör Textlabbet det enkelt att hålla reda på dina skrivprojekt och se din utveckling över tid. Oavsett om du arbetar med akademiska uppsatser, professionella rapporter, kreativt skrivande eller något däremellan, är Textlabbet din perfekta skrivpartner.",
    icon: <CreateIcon />,
    //video: { light: "/img/t-l.mp4", dark: "/img/t-d.mp4" },

    img: {
      light: "/img/textlabbet.png",
      dark: "/img/textlabbet.png",
    },

    heroImage: {
      light: "/img/textlabbet-hero-video-l.mp4",
      dark: "/img/textlabbet-hero-video-l.mp4",
    },
    details: [
      {
        text: "Textanalys: Använd AI för att summera långa texter, genomföra djupgående analyser och tillhandahålla konstruktiv kritik.",
        icon: <FindInPageIcon />,
      },
      {
        text: "Omstrukturering: Förbättra flödet och läsbarheten i  texterna genom att modernisera språket och omorganisera innehållet på ett logiskt och sammanhängande sätt.",
        icon: <AutoFixHighIcon />,
      },
      {
        text: "Redigering: Låt AI assistera dig med att korrigera grammatiska fel, förbättra  stilistiken och optimera textens struktur för att uppnå professionell kvalitet.",
        icon: <SpellcheckIcon />,
      },

      {
        text: "Textlagring: Håll ordning på dina dokument genom att spara och organisera dina redigerade texter på ett lättillgängligt sätt för framtida referens.",
        icon: <SaveIcon />,
      },

      {
        text: "Variera: Skapa olika versioner av din text utan att ändra innebörden.",
        icon: <ShuffleIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Summera: Sammanfatta texten kortfattat för snabb överblick.",
        icon: <SummarizeIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Formatera: Förbättra textens layout med rubriker, stycken och fetstil.",
        icon: <FormatAlignLeftIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Komplicera: Gör texten mer komplex och avancerad för en kunnig målgrupp.",
        icon: <BuildIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Förenkla: Gör texten lättare att förstå för en bredare publik.",
        icon: <AutoFixHighIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Faktakolla: Verifiera påståenden mot tillförlitliga källor.",
        icon: <FactCheckIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Punktlista: Omvandla text till tydliga, lättlästa punktlistor.",
        icon: <FormatListBulletedIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Förbättra: Optimera textens flyt och ton för bättre engagemang.",
        icon: <TrendingUpIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Metaforifiera: Lägg till bildspråk för en mer målande text.",
        icon: <BrushIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Krydda: Förstärk texten med kraftfullare adjektiv och adverb.",
        icon: <LocalFloristIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Förkorta: Komprimera texten utan att förlora viktigt innehåll.",
        icon: <CompressIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Förlänga: Utöka texten med fler detaljer och förklaringar.",
        icon: <ExpandIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Parafrasera: Omformulera texten med bibehållen innebörd.",
        icon: <RepeatIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Analysera: Utför djupgående analys av textens innehåll och struktur.",
        icon: <AnalyticsIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Kritisera: Få konstruktiv feedback på textens innehåll och upplägg.",
        icon: <RateReviewIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Omstrukturera: Förbättra textens flöde och läsbarhet.",
        icon: <ViewStreamIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Kontextualisera: Placera texten i ett bredare sammanhang.",
        icon: <LanguageIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Modernisera: Uppdatera texten till ett mer samtida språkbruk.",
        icon: <UpdateIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Arkaisera: Ge texten en historisk prägel med äldre språkbruk.",
        icon: <HistoryIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Rätta: Korrigera stavfel och grammatiska fel med tydlig markering.",
        icon: <SpellcheckIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Konceptualisera: Extrahera textens grundläggande koncept och idéer.",
        icon: <LightbulbIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Brainstorma: Generera nya idéer relaterade till textens ämne.",
        icon: <EmojiObjectsIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Ordfrekvensberäkna: Analysera ordanvändning och frekvens i texten.",
        icon: <BarChartIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Humorisera: Lägg till humoristiska inslag i texten.",
        icon: <SentimentVerySatisfiedIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Dramatisera: Förstärk textens känslomässiga och dramatiska element.",
        icon: <TheaterComedyIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Poetisera: Omvandla texten till en poetisk form med rim och rytm.",
        icon: <MusicNoteIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Argumentationsanalysera: Identifiera och utvärdera textens argument.",
        icon: <GavelIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Jämför koncept & idéer: Skapa strukturerade jämförelser i texten.",
        icon: <CompareArrowsIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Intertextuell analys: Hitta kopplingar till andra relevanta texter.",
        icon: <LinkIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Generera studieuppgifter: Skapa frågor och uppgifter baserade på texten.",
        icon: <AssignmentIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Generera flervalsfrågor: Skapa ett prov med flervalsfrågor från texten.",
        icon: <QuizIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Generera fyll-i-luckan-frågor: Skapa övningar baserade på textens innehåll.",
        icon: <TextFieldsIcon />,
        showInFeaturePage: true,
      },
    ],
    pros: [
      {
        text: "Erbjuder en omfattande uppsättning verktyg för textanalys och förbättring",
        icon: <BuildIcon />,
      },
      {
        text: "Anpassningsbar för olika typer av texter och skrivbehov",
        icon: <TuneIcon />,
      },
      {
        text: "Hjälper skribenter att utveckla sin stil och förbättra textens kvalitet",
        icon: <TrendingUpIcon />,
      },
    ],
    steps: [
      {
        title: "Ladda upp eller skriv in text",
        description:
          "Börja med att ladda upp ett dokument eller skriva in din text direkt i Textlabbet.",
      },
      {
        title: "Välj önskad funktion",
        description:
          "Välj bland de många AI-drivna verktygen för att analysera och förbättra din text.",
      },
      {
        title: "Granska och applicera ändringar",
        description:
          "Granska AI:ns förslag, gör nödvändiga justeringar och applicera de önskade ändringarna på din text.",
      },
      {
        title: "Spara och organisera",
        description:
          "Spara dina förbättrade texter och organisera dem för enkel åtkomst i framtiden.",
      },
    ],
    typeAnimationSequence: [
      "Förvandla dina texter med AI ",
      1000,
      "Analysera och förbättra innehåll ",
      1000,
      "Variera och anpassa språkstil ",
      1000,
      "Generera studiehjälpmedel ",
      1000,
      "Optimera textstruktur och flöde ",
      1000,
      "Utforska kreativa skrivtekniker ",
      1000,
      "Fördjupa textförståelse och analys ",
      1000,
    ],
  },

  // {
  //   title: 'Betygsätt uppsatser med AI',
  //   description:
  //     'Spara tid och få hjälp att rättvist och objektivt bedöma elevers uppsatser med AI – anpassa omdömena och spara för smidig hantering.',
  //   icon: '<InsertDriveFileIcon />',
  //   details: [
  //     {
  //       text: 'Ladda upp och bedöm uppsatser: Ladda upp elevers uppsatser eller klistra in deras text för bedömning. AI hjälper till att säkerställa objektivitet, och du kan sedan redigera och anpassa omdömet innan det sparas.',
  //       icon: <InsertDriveFileIcon />,
  //     },
  //     {
  //       text: 'Anpassad feedback: Välj en av de fördefinierade bedömningsmatriserna (expositiv, argumenterande, beskrivande, berättande) eller skapa din egen. Ge eleverna tydlig och anpassad återkoppling på deras arbete.',
  //       icon: <AssessmentIcon />,
  //     },
  //     {
  //       text: 'Standardiserad bedömning: AI säkerställer att alla uppsatser bedöms konsekvent och rättvist, utan påverkan av subjektiva åsikter.',
  //       icon: <VerifiedUserIcon />,
  //     },
  //     {
  //       text: 'Detaljerad analys och förbättringsförslag: AI genererar en detaljerad analys av varje uppsats med specifika tips för förbättring. Spara och skriv ut omdömen för att ha en översikt över all feedback.',
  //       icon: <EmojiObjectsIcon />,
  //     },
  //     {
  //       text: 'Fokusera på individanpassad undervisning: Använd tiden du sparar för att ge elever med särskilda behov den extra uppmärksamhet de behöver.',
  //       icon: <AccessibilityNewIcon />,
  //     },
  //   ],
  // },

  {
    title: "Betygsätt uppsatser med AI",
    titleSEO: "Betygsätt uppsatser med AI",
    hideOnStartpage: true,
    description:
      "Spara tid och få hjälp att rättvist och objektivt bedöma elevers uppsatser med AI – anpassa omdömena och spara för smidig hantering.",
    descriptionSEO:
      "Spara tid och få hjälp att rättvist och objektivt bedöma elevers uppsatser med AI. Anpassa omdömen, spara för smidig hantering, och säkerställ konsekvent bedömning.",
    descriptionLonger:
      "Spara tid och få hjälp att rättvist och objektivt bedöma elevers uppsatser med AI. Anpassa omdömen, spara för smidig hantering, och säkerställ konsekvent bedömning av alla uppsatser.",

    aboutText:
      "Vår funktion för att betygsätta uppsatser med AI är utformad för att förändra sättet lärare bedömer elevers arbete. Genom att utnyttja den senaste AI-teknologin kan du spara värdefull tid och säkerställa en objektiv, rättvis och konsekvent bedömning av alla uppsatser.\n\nAI analyserar texterna med hjälp av fördefinierade eller anpassade bedömningsmatriser, vilket minskar risken för partiskhet och garanterar att varje elev bedöms utifrån samma kriterier.\n\nAtt betygsätta uppsatser med AI gör din bedömningsprocess snabbare, mer konsekvent och rättvis – samtidigt som du behåller kontrollen över den slutgiltiga bedömningen. Detta frigör även resurser för lärare att fokusera på att ge individuell feedback, planera lektioner och stödja elevernas utveckling.",
    icon: <InsertDriveFileIcon />,
    video: {
      light: "/img/betygsatt-uppsatser-l.mp4",
      dark: "/img/betygsatt-uppsatser-d.mp4",
    },
    heroImage: {
      light: "/img/uppsatser-hero-image-l.png",
      dark: "/img/uppsatser-hero-image-l.png",
    },

    details: [
      {
        text: "Betygsätt uppsatser med AI: Använd AI för att analysera uppsatser utifrån fördefinierade eller anpassade bedömningsmatriser, vilket säkerställer objektiv och konsekvent bedömning.",
        icon: <AutoFixHighIcon />,
      },
      {
        text: "Anpassningsbara omdömen: Granska och redigera AI-genererade omdömen för att säkerställa att bedömningen passar varje enskild elevs arbete och utvecklingsbehov.",
        icon: <CreateIcon />,
      },
      {
        text: "Tidsbesparande: Effektivisera bedömningsprocessen genom att låta AI göra den initiala analysen, så att du kan fokusera på att ge värdefull feedback och stöd till eleverna.",
        icon: <AccessTimeIcon />,
      },
      {
        text: "Konsekvent bedömning: Säkerställ att alla uppsatser bedöms utifrån samma kriterier, vilket främjar rättvisa och transparens i bedömningsprocessen.",
        icon: <BalanceIcon />,
      },
      {
        text: "Spara och organisera: Lagra bedömningar och omdömen på ett strukturerat sätt för enkel åtkomst, uppföljning och dokumentation av elevers progression över tid.",
        icon: <FolderIcon />,
      },
      {
        text: "Anpassad feedback: Välj en av de fördefinierade bedömningsmatriserna (expositiv, argumenterande, beskrivande, berättande) eller skapa din egen. Ge eleverna tydlig och anpassad återkoppling på deras arbete.",
        icon: <AssessmentIcon />,
      },
    ],
    pros: [
      {
        text: "Sparar tid och effektiviserar bedömningsprocessen",
        icon: <SpeedIcon />,
      },
      {
        text: "Säkerställer konsekvent och rättvis bedömning",
        icon: <VerifiedUserIcon />,
      },
      {
        text: "Ger lärare mer tid att fokusera på individuell feedback och stöd",
        icon: <PeopleIcon />,
      },
    ],
    steps: [
      {
        title: "Ladda upp uppsats",
        description:
          "Ladda upp elevens uppsats eller klistra in texten direkt i systemet.",
        image: "/img/uppsatser-steg-1-l.png",
      },
      {
        title: "AI-analys",
        description:
          "AI analyserar uppsatsen baserat på valda bedömningskriterier och genererar ett förslag på omdöme.",
        image: "/img/uppsatser-steg-2-l.png",
      },
      {
        title: "Granska och anpassa",
        description:
          "Granska AI:ns förslag, gör nödvändiga justeringar och lägg till personlig feedback.",
        image: "/img/uppsatser-steg-3-l.png",
      },
    ],
    typeAnimationSequence: [
      "Spara tid vid bedömning av uppsatser ",
      1000,
      "Säkerställ konsekvent och rättvis bedömning ",
      1000,
      "Anpassa AI-genererade omdömen ",
      1000,
      "Fokusera på att ge värdefull feedback ",
      1000,
      "Organisera och spara bedömningar enkelt ",
      1000,
      "Följ elevers progression över tid ",
      1000,
    ],
  },

  // {
  //   title: 'AI-lärare',
  //   description: 'Chatta med anpassade AI-karaktärer och historiska figurer.',
  //   icon: <SchoolIcon />,
  //   video: { light: '/img/k-l.mp4', dark: '/img/k-d.mp4' },
  //   goDirectlyToApp: true,
  //   details: [
  //     {
  //       text: 'Anpassade lärare: Skapa din egen AI-karaktär genom att ange specifika instruktioner och preferenser, vilket ger dig en skräddarsydd inlärningsupplevelse.',
  //       icon: <BuildIcon />,
  //     },
  //     {
  //       text: 'Inkluderande lärande: Välj bland en mängd olika AI-lärare anpassade för olika inlärningsstilar och behov, vilket säkerställer att du får den mest effektiva undervisningen.',
  //       icon: <AccessibilityNewIcon />,
  //     },
  //     {
  //       text: 'Historiska dialoger: Engagera dig i konversationer med virtuella representationer av kända tänkare och vetenskapsmän för att fördjupa din förståelse för deras idéer och bidrag.',
  //       icon: <HistoryEduIcon />,
  //     },
  //   ],
  // },

  // {
  //   title: "AI-lärare",
  //   titleSEO: "AI-lärare - Skapa din personliga virtuella lärare",
  //   description:
  //     "Chatta med anpassade AI-karaktärer och historiska figurer för en skräddarsydd inlärningsupplevelse.",
  //   descriptionSEO:
  //     "Skapa din egen virtuella lärare med AI. Anpassa inlärningen efter dina behov, lär dig i din egen takt och få personlig hjälp dygnet runt.",
  //   descriptionLonger:
  //     "Skapa din drömlärare anpassad efter dina individuella behov för att lära dig i din egen takt utan stress och press. Chatta med AI-lärare inom olika ämnen som historia, matematik och språk. Anpassa lärarens beteende, spara och dela konversationer, och generera quiz baserat på dina samtal för att förstärka din inlärning.",
  //   aboutText:
  //     "AI-lärare representerar nästa steg i personlig utbildning, där teknologi möter individualiserad inlärning. Denna funktion låter dig skapa din egen virtuella lärare, perfekt anpassad efter dina unika behov, inlärningsstil och utbildningsmål.\n\nMed AI-lärare kan du lära dig i din egen takt, utan stress eller press från klasskompisar eller tidsbegränsningar. Du kan interagera med specialiserade lärare inom olika ämnen - från historielärare och matematiklärare till språklärare och historiska personer såsom Albert Einstein och Virginia Woolf. Detta ger dig möjlighet att fördjupa dig i specifika ämnen och få expertkunskap precis när du behöver det.\n\nEn av de mest spännande aspekterna av AI-lärare är dess användning i verkliga utbildningssituationer. Till exempel används vår svenska AI-lärare redan för SFI (Svenska för invandrare) bland nyanlända, vilket hjälper dem att snabbare integrera sig i det svenska samhället. Många använder också vår spansklärare för att lära sig spanska, vilket visar på systemets mångsidighet och effektivitet i språkinlärning.\n\nAI-läraren erbjuder också möjligheten att spara meddelanden och dela konversationer med andra, som till exempel dina lärare. Detta underlättar uppföljning och ger möjlighet för traditionella lärare att se dina framsteg och ge ytterligare vägledning.\n\nEn unik funktion är möjligheten att när som helst redigera instruktionerna till din AI-lärare. Detta innebär att du kan finjustera lärarens beteende för att passa dina specifika behov eller preferenser. Om du till exempel föredrar en mer direkt kommunikationsstil eller behöver extra förklaringar inom vissa områden, kan du enkelt anpassa din lärare för att möta dessa behov.\n\nVi har också lagt särskild vikt vid tillgänglighet och inkludering. AI-läraren kan anpassas för olika inlärningsstilar och behov, inklusive inställningar för ADHD- eller dyslexianpassning. Detta säkerställer att alla elever, oavsett deras specifika utmaningar, kan dra nytta av personlig, anpassad undervisning.\n\nFör att förstärka inlärningen och göra processen mer engagerande, erbjuder vi också möjligheten att generera quiz baserat på dina konversationer. Efter att exempelvis ha chattat med historieläraren om andra världskriget kan du till exempel få ett quiz på konversationen för att se hur mycket du kommer ihåg och identifiera områden som behöver mer fokus.\n\n En annan aspekt är att du kan spara tid och effektivisera din inlärning genom att skapa och återanvända anpassade prompts. Till exempel kan du skapa en prompt för din historielärare som ber om en kronologisk översikt av viktiga händelser, eller en prompt för din mattelärare som ber om steg-för-steg-lösningar på problem. För språkinlärning kan du ha en prompt som ber om daglig vokabulärträning eller grammatikövningar. \n\nAI-läraren är utformad för att vara ett komplement till, inte en ersättning för, traditionell undervisning. Det är det nya moderna sättet att lära sig med AI som stöd, vilket ger dig möjligheten att utforska, lära och växa i din egen takt, med outtröttligt stöd och vägledning tillgänglig dygnet runt.",
  //   icon: "<SchoolIcon />",
  //   video: {
  //     light: "/img/k-l.mp4",
  //     dark: "/img/k-d.mp4",
  //   },
  //   heroImage: {
  //     light: "/img/lar-dig-sprak-hero-video-l.mp4",
  //     dark: "/img/lar-dig-sprak-hero-video-l.mp4",
  //   },
  //   details: [
  //     {
  //       text: "Skapa din drömlärare: Anpassa AI-läraren efter dina behov och preferenser för att skapa en personlig inlärningsupplevelse.",
  //       icon: <BuildIcon />,
  //     },

  //     {
  //       text: "Inkluderande lärande: Välj bland en mängd olika AI-lärare anpassade för olika inlärningsstilar och behov, inklusive ADHD- och dyslexianpassade inställningar.",
  //       icon: <AccessibilityNewIcon />,
  //     },
  //     {
  //       text: "Historiska dialoger: Engagera dig i konversationer med virtuella representationer av kända tänkare och vetenskapsmän för att fördjupa din förståelse för deras idéer och bidrag.",
  //       icon: <HistoryEduIcon />,
  //     },
  //     {
  //       text: "Spara och dela: Spara viktiga meddelanden och dela hela konversationer med dina lärare för uppföljning och ytterligare vägledning.",
  //       icon: <ShareIcon />,
  //       showInFeaturePage: true,
  //     },

  //     {
  //       text: "Redigerbara instruktioner: Anpassa din AI-lärares beteende när som helst genom att justera instruktionerna för att matcha dina inlärningsbehov.",
  //       icon: <SettingsIcon />,
  //       showInFeaturePage: true,
  //     },
  //     {
  //       text: "Individuell inlärningstakt: Lär dig i din egen takt utan stress och press, och undvik risken att göra bort dig inför klasskompisar.",
  //       icon: <SpeedIcon />,
  //       showInFeaturePage: true,
  //     },
  //     {
  //       text: "Generera quiz: Skapa interaktiva quiz baserade på dina konversationer med AI-läraren för att testa din förståelse och identifiera områden som behöver mer fokus.",
  //       icon: <QuizIcon />,
  //       showInFeaturePage: true,
  //     },
  //     {
  //       text: "Språkinlärning: Använd specialiserade AI-lärare för språkinlärning, som vår svenska AI-lärare för SFI eller spansklärare för att lära dig spanska.",
  //       icon: <TranslateIcon />,
  //       showInFeaturePage: true,
  //     },
  //     {
  //       text: "Skapa anpassade prompts: Spara tid och effektivisera din inlärning genom att skapa och återanvända anpassade prompts. Till exempel kan du skapa en prompt för din mattelärare som ber om steg-för-steg-förklaringar på problem.",
  //       icon: <BookmarkIcon />,
  //       showInFeaturePage: true,
  //     },
  //     {
  //       text: "24/7 tillgänglighet: Få hjälp och stöd när du behöver det, oavsett tid på dygnet, vilket möjliggör flexibel inlärning på dina villkor.",
  //       icon: <AccessTimeIcon />,
  //       showInFeaturePage: true,
  //     },
  //     {
  //       text: "Stressfri miljö: Lär dig utan rädsla för att göra fel inför andra, vilket skapar en trygg inlärningsmiljö.",
  //       icon: <SentimentVerySatisfiedIcon />,
  //       showInFeaturePage: true,
  //     },
  //   ],
  //   pros: [
  //     {
  //       text: "Personlig och anpassningsbar inlärningsupplevelse",
  //       icon: "<TuneIcon />",
  //     },
  //     {
  //       text: "Lär dig i din egen takt utan stress eller press",
  //       icon: "<SpeedIcon />",
  //     },
  //     {
  //       text: "Tillgång till specialiserad kunskap inom olika ämnesområden",
  //       icon: "<SchoolIcon />",
  //     },
  //   ],
  //   steps: [
  //     {
  //       title: "Välj eller skapa din AI-lärare",
  //       description:
  //         "Börja med att välja en fördefinierad AI-lärare eller skapa en egen genom att ange specifika instruktioner och preferenser.",
  //     },
  //     {
  //       title: "Börja din inlärningsresa",
  //       description:
  //         "Interagera med din AI-lärare genom att ställa frågor, be om förklaringar eller diskutera ämnen du är intresserad av.",
  //     },
  //     {
  //       title: "Anpassa och förbättra",
  //       description:
  //         "Justera din AI-lärares instruktioner efter behov och använd funktioner som quiz-generering för att förstärka din inlärning.",
  //     },
  //     {
  //       title: "Följ upp och dela framsteg",
  //       description:
  //         "Spara viktiga konversationer, dela dem med dina mänskliga lärare och använd insikterna för att kontinuerligt förbättra din inlärningsprocess.",
  //     },
  //   ],
  //   typeAnimationSequence: [
  //     "Skapa din personliga AI-lärare ",
  //     1000,
  //     "Lär dig i din egen takt ",
  //     1000,
  //     "Få hjälp dygnet runt ",
  //     1000,
  //     "Anpassa inlärningen efter dina behov ",
  //     1000,
  //     "Interagera med historiska figurer ",
  //     1000,
  //     "Generera quiz baserat på dina samtal ",
  //     1000,
  //     "Dela framsteg med dina lärare ",
  //     1000,
  //   ],
  // },

  {
    title: "Högskoleprovet",
    titleSEO: "Träna på gamla och AI-genererade högskoleprov",
    description: "Träna på gamla och AI-genererade högskoleprov.",
    descriptionSEO:
      "Förbättra dina chanser att komma in på drömutbildningen genom att träna på gamla och AI-genererade högskoleprov. Få personlig feedback och följ din utveckling över tid.",
    descriptionLonger:
      "Maximera dina chanser att lyckas på högskoleprovet genom att träna på både gamla högskoleprov och AI-genererade högskoleprov. Få djupgående förklaringar, personlig feedback och följ din utveckling för att nå dina studiemål.",
    aboutText:
      "Att förbereda sig för högskoleprovet har aldrig varit enklare eller mer effektivt. Genom att kombinera gamla högskoleprov med AI-genererade prov, får du en unik och omfattande träningsupplevelse.\n\nMed tillgång till ett omfattande arkiv av tidigare högskoleprov kan du bekanta dig med provets format, svårighetsgrad och frågetyper. Detta ger dig en autentisk upplevelse och hjälper dig att bygga självförtroende inför provdagen.\n\nTröttnar du på de gamla högskoleprovet så kan du be vår AI-modell att generera unika frågor som kompletterar de gamla proven. Detta ger dig obegränsad övning och hjälper dig att täcka alla tänkbara ämnesområden och frågetyper som kan dyka upp på provet. Denna exceptionella kombination av gamla och AI-genererade prov ger dig en mångsidig och djupgående förberedelse. Du kan snabbt växla mellan olika pågående tester, spåra dina framsteg över tid och identifiera områden som behöver extra uppmärksamhet.\n\nVår plattform låter även användare betygsätta olika högskoleprov (både gamla och AI-genererade), vilket skapar en topplista över de mest populära och hjälpsamma proven. Detta gemenskapsdrivna system hjälper dig att hitta det mest värdefulla övningsmaterialet.\n\nUnder tiden du arbetar med frågorna kan du använda smidiga genvägar för att snabbt be AI om hjälp eller förklaringar. Detta gör att du kan fördjupa din förståelse av svåra koncept i realtid. Du kan också enkelt spara frågor för att återkomma till dem senare, vilket underlättar repetition av utmanande ämnen.\n\nMed detta moderna sätt att öva på högskoleprovet får du inte bara övning - du får en personlig, adaptiv och engagerande inlärningsupplevelse som maximerar dina chanser att lyckas på provdagen.",
    icon: <MenuBookIcon />,
    //video: { light: "/img/h-l.mp4", dark: "/img/h-d.mp4" },

    img: {
      light: "/img/hogskole.png",
      dark: "/img/hogskole.png",
    },

    heroImage: {
      light: "/img/hogskoleprovet-hero-video-l.mp4",
      dark: "/img/hogskoleprovet-hero-video-l.mp4",
    },
    details: [
      {
        text: "Gamla högskoleprov: Träna på gamla högskoleprov för att veta vad som väntar dig när det är dags för provdagen.",
        icon: <GradeIcon />,
      },
      {
        text: "AI-assistans: Dra nytta av AI-genererade förklaringar och lösningar för varje fråga, vilket hjälper dig att förstå koncepten bakom svaren och förbättra din prestation.",
        icon: <LiveHelpIcon />,
      },
      {
        text: "Generera egna prov med AI: Generera skräddarsydda prov som täcker alla delar av högskoleprovet, inklusive ORD, LÄS, MEK, XYZ och ELF, för att förbereda dig inför testet.",
        icon: <CreateIcon />,
      },
      {
        text: "Övervaka framsteg: Följ dina framsteg över tid med detaljerade rapporter och analyser, vilket hjälper dig att identifiera styrkor och svagheter.",
        icon: <TrendingUpIcon />,
      },
      {
        text: "Anpassad träning: Få rekommendationer på vilka områden du bör fokusera på baserat på dina resultat, så att du kan effektivisera din studietid.",
        icon: <FitnessCenterIcon />,
      },

      {
        text: "Snabb växling mellan prov: Byt enkelt mellan olika pågående tester för varierad och effektiv övning.",
        icon: <ShuffleIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Betygsättning av prov: Användare kan betygsätta både gamla och AI-genererade prov för att skapa en topplista över de mest hjälpsamma övningsmaterialen.",
        icon: <StarIcon />,
        showInFeaturePage: true,
      },
      {
        text: "AI-förklaringar: Använd snabbkommandon för att be om AI-assisterade förklaringar till svåra frågor i realtid.",
        icon: <EmojiObjectsIcon />,
        showInFeaturePage: true,
      },
      {
        text: "Spara frågor: Markera och spara utmanande frågor för enkel åtkomst och repetition senare.",
        icon: <BookmarkIcon />,
        showInFeaturePage: true,
      },
    ],
    pros: [
      {
        text: "Omfattande förberedelse med både gamla och AI-genererade prov",
        icon: <MenuBookIcon />,
      },
      {
        text: "Personlig feedback och anpassade rekommendationer",
        icon: <TuneIcon />,
      },
      {
        text: "Interaktiv och engagerande inlärningsupplevelse",
        icon: <EmojiObjectsIcon />,
      },
    ],
    steps: [
      {
        title: "Välj provtyp",
        description:
          "Börja med att välja mellan ett gammalt högskoleprov eller ett AI-genererat prov.",
      },
      {
        title: "Genomför provet",
        description:
          "Ta provet under realistiska förhållanden, använd AI-assistans vid behov.",
      },
      {
        title: "Granska resultat",
        description:
          "Analysera dina resultat, förstå dina misstag och identifiera förbättringsområden.",
      },
      {
        title: "Anpassa din träning",
        description:
          "Använd insikterna för att fokusera din träning på områden som behöver förbättras.",
      },
    ],
    typeAnimationSequence: [
      "Förbered dig för Högskoleprovet ",
      1000,
      "Träna på autentiska gamla prov ",
      1000,
      "Utmana dig med AI-genererade frågor ",
      1000,
      "Få personlig feedback och förklaringar ",
      1000,
      "Följ din utveckling över tid ",
      1000,
      "Maximera dina chanser att lyckas ",
      1000,
    ],
  },

  {
    title: "AI-debatt",
    description: "Simulera en debatt mellan dig själv och en historisk person.",
    icon: <QuestionAnswerIcon />,
    //    video: { light: "/img/debatt-l.mp4", dark: "/img/debatt-d.mp4" },

    img: {
      light: "/img/debatt.png",
      dark: "/img/debatt.png",
    },

    details: [
      {
        text: "Argumentationsteknik: Förbättra dina argumentationsförmågor genom engagerande och interaktiva debatter, vilket hjälper dig att uttrycka dina idéer mer effektivt och övertygande.",
        icon: <ForumIcon />,
      },
      {
        text: "Historiska simuleringar: Delta i virtuella debatter med framstående historiska figurer som Sigmund Freud och Carl Jung, och få insikt i deras tankesätt och teorier.",
        icon: <HistoryEduIcon />,
      },
      {
        text: "Faktakoll: Säkerställ korrekthet i dina debatter genom att verifiera argument och påståenden direkt under diskussionen.",
        icon: <VerifiedUserIcon />,
      },
      {
        text: "Fördjupad förståelse: Få en djupare insikt i komplexa ämnen genom att analysera och diskutera dem ur flera olika perspektiv.",
        icon: <PsychologyIcon />,
      },
    ],
  },

  // {
  //   title: "AI-detektor",
  //   titleSEO: "AI-detektor - Identifiera AI-genererad text",
  //   description:
  //     "Analysera text för att kontrollera huruvida den är AI-genererad eller ej.",
  //   descriptionSEO:
  //     "Använd vår AI-detektor för att analysera och identifiera AI-genererad text. Perfekt för lärare och studenter som vill säkerställa textens autenticitet.",
  //   descriptionLonger:
  //     "Vår AI-detektor använder avancerad språkteknologi för att analysera och identifiera om en text är genererad av AI eller skriven av en människa. Detta verktyg är ovärderligt för lärare och studenter som vill säkerställa textens autenticitet och integritet.",
  //   aboutText:
  //     "AI-detektorn är ett sofistikerat verktyg designat för att möta de växande utmaningarna med att skilja mellan mänskligt och AI-genererat innehåll. Genom att utnyttja avancerade algoritmer och maskininlärningstekniker, analyserar vår svenska AI-detektor subtila språkmönster, stilistiska egenskaper och strukturella element som ofta skiljer AI-genererad text från mänskligt författad text.\n\nFör lärare erbjuder detta verktyg en möjlighet att upprätthålla akademisk integritet genom att identifiera potentiellt plagierat eller AI-genererat material i studentarbeten. Studenter kan använda det för att säkerställa att deras eget arbete inte oavsiktligt liknar AI-genererat innehåll, och därmed undvika eventuella anklagelser om fusk.\n\nFör professionella skribenter och redaktörer fungerar AI-detektorn som ett kvalitetssäkringsverktyg, som hjälper till att upprätthålla autenticiteten i publicerat material. I en tid där AI-genererat innehåll blir allt vanligare, ger vår detektor användarna möjlighet att göra informerade beslut om textens ursprung och kvalitet.\n\nDet är dock viktigt att notera att medan vår AI-detektor är ett kraftfullt verktyg, bör den användas som en del av en bredare bedömningsprocess. Mänsklig bedömning och kontext är fortfarande avgörande för att göra slutgiltiga utvärderingar av en texts ursprung och kvalitet.",
  //   icon: "<AssessmentIcon />",
  //   video: { light: "/img/aid-l.mp4", dark: "/img/aid-d.mp4" },
  //   heroImage: {
  //     light: "/img/ai-detektor-hero-video-l.mp4",
  //     dark: "/img/ai-detektor-hero-video-l.mp4",
  //   },
  //   details: [
  //     {
  //       text: "Lingvistisk analys: Använd avancerad språkteknologi för att identifiera och analysera lingvistiska mönster som ofta förekommer i AI-genererad text, vilket hjälper dig att avgöra textens ursprung.",
  //       icon: <FindInPageIcon />,
  //     },
  //     {
  //       text: "Stilometrisk profilering: Utför en detaljerad analys av författarens stil för att upptäcka eventuella avvikelser eller inkonsekvenser som kan indikera AI-generering.",
  //       icon: <FingerprintIcon />,
  //     },
  //     {
  //       text: "Diskursanalys: Analysera strukturen och flödet av argument och idéer för att avgöra om texten följer typiska mänskliga mönster eller om den är genererad av AI.",
  //       icon: <CompareArrowsIcon />,
  //     },
  //     {
  //       text: "Sannolikhetsbedömning: Få en procentuell bedömning av sannolikheten att texten är AI-genererad, baserat på en kombination av olika analysfaktorer.",
  //       icon: <BarChartIcon />,
  //       showInFeaturePage: true,
  //     },
  //     {
  //       text: "Detaljerad rapport: Generera en omfattande rapport som belyser specifika textavsnitt och egenskaper som bidrar till bedömningen.",
  //       icon: <AssessmentIcon />,
  //       showInFeaturePage: true,
  //     },
  //     {
  //       text: "Jämförande analys: Jämför den analyserade texten med en databas av kända AI-genererade och mänskligt skrivna texter för att identifiera likheter och skillnader.",
  //       icon: <CompareArrowsIcon />,
  //       showInFeaturePage: true,
  //     },
  //     {
  //       text: "Anpassningsbara tröskelvärden: Justera känsligheten i detektorn baserat på dina specifika behov och den typ av text som analyseras.",
  //       icon: <TuneIcon />,
  //       showInFeaturePage: true,
  //     },
  //     {
  //       text: "Flerspråkigt stöd: Analysera texter på flera olika språk för att möta globala behov av innehållsverifiering.",
  //       icon: <TranslateIcon />,
  //       showInFeaturePage: true,
  //     },
  //     {
  //       text: "Batchanalys: Ladda upp och analysera flera dokument samtidigt för effektiv hantering av stora textmängder.",
  //       icon: <ViewStreamIcon />,
  //       showInFeaturePage: true,
  //     },
  //   ],
  //   pros: [
  //     {
  //       text: "Hjälper till att upprätthålla akademisk integritet",
  //       icon: <VerifiedUserIcon />,
  //     },
  //     {
  //       text: "Ger insikt i textens autenticitet och ursprung",
  //       icon: <VisibilityIcon />,
  //     },
  //     {
  //       text: "Stödjer både lärare och studenter i att säkerställa originalitet",
  //       icon: <SchoolIcon />,
  //     },
  //   ],
  //   steps: [
  //     {
  //       title: "Ladda upp text",
  //       description:
  //         "Börja med att ladda upp eller klistra in den text du vill analysera i AI-detektorn.",
  //     },
  //     {
  //       title: "Kör analys",
  //       description:
  //         "Starta analysen och låt AI-detektorn bearbeta texten genom sina olika analysmetoder.",
  //     },
  //     {
  //       title: "Granska resultat",
  //       description:
  //         "Granska den detaljerade rapporten som visar sannolikheten för AI-generering och specifika textegenskaper som bidrar till bedömningen.",
  //     },
  //     {
  //       title: "Tolka och agera",
  //       description:
  //         "Använd resultaten som en del av en bredare bedömningsprocess, med hänsyn till kontext och mänsklig bedömning.",
  //     },
  //   ],
  //   typeAnimationSequence: [
  //     "Analysera text för AI-generering ",
  //     1000,
  //     "Säkerställ akademisk integritet ",
  //     1000,
  //     "Identifiera lingvistiska mönster ",
  //     1000,
  //     "Jämför med kända textdatabaser ",
  //     1000,
  //     "Generera detaljerade rapporter ",
  //     1000,
  //     "Anpassa efter dina specifika behov ",
  //     1000,
  //     "Stöd för flera språk ",
  //     1000,
  //   ],
  // },

  // {
  //   title: "Generera text med AI",
  //   titleSEO: "Generera text med AI",
  //   description:
  //     "Skapa högkvalitativa texter med hjälp av avancerad AI-teknologi.",
  //   descriptionSEO:
  //     "Använd AI för att snabbt och enkelt generera högkvalitativa texter inom vilket ämne som helst. Effektivisera ditt skrivande och spara tid med vår AI-drivna textgenerator.",
  //   descriptionLonger:
  //     "Använd AI för att skapa högkvalitativa texter inom vilket ämne som helst. Effektivisera ditt skrivande, få inspiration och spara tid med vår AI-drivna textgenerator. Anpassa tonen, stilen och längden på dina texter för att passa dina specifika behov.",
  //   aboutText:
  //     "Vår AI-drivna textgenerator representerar ett betydande framsteg inom språkteknologi och erbjuder användare möjligheten att skapa sofistikerat, kontextbaserat innehåll med enastående hastighet och precision. Denna avancerade funktion utnyttjar de senaste framstegen inom naturlig språkbehandling och maskininlärning för att producera texter som är nästan omöjliga att skilja från mänskligt författade verk.\n\nTextgeneratorn är designad för att möta en mängd olika behov och kan anpassas för att producera allt från akademiska uppsatser, kreativa berättelser, marknadsföringsmaterial och tekniska dokument. Genom att använda kontextuella ledtrådar och användardefinierade parametrar kan AI:n generera innehåll som är skräddarsytt för specifika ämnen, målgrupper och stilistiska preferenser.\n\nEn av de mest imponerande aspekterna av vår textgenerator är dess förmåga att förstå och efterlikna olika toner. Vare sig du behöver en formell ton för en vetenskaplig artikel, en avslappnad stil för ett blogginlägg, eller en övertygande röst för reklamtext, kan AI:n anpassa sig efter dina behov. Detta gör den till ett oumbärligt verktyg för författare, marknadsförare, studenter, lärare och professionella i alla branscher som regelbundet producerar skrivet innehåll.\n\nDessutom erbjuder vår textgenerator avancerade funktioner som möjligheten att expandera på givna ämnen, generera idéer för nytt innehåll, och till och med hjälpa till att övervinna skrivkramp genom att föreslå nya riktningar eller perspektiv. Med inbyggda verktyg för faktakontroll och källhänvisningar säkerställer vi att det genererade innehållet inte bara är engagerande utan också tillförlitligt.\n\nMed vår AI-textgenerator kan användare dramatiskt öka sin produktivitet och kreativitet. Den fungerar som en outtröttlig samarbetspartner som kan hjälpa till att snabbt producera utkast, förfina idéer och utforska nya koncept. Samtidigt är det viktigt att notera att medan AI:n är ett kraftfullt verktyg, är den utformad för att förstärka och stödja mänsklig kreativitet snarare än att ersätta den. Den mest effektiva användningen kommer från ett samspel mellan AI:ns kapacitet och användarens unika insikter och expertis.\n\nI en tid då innehållsproduktion är viktigare än någonsin, erbjuder vår textgenerator en konkurrensfördel genom att möjliggöra snabb skapande av högkvalitativt, originellt innehåll i stor skala. Vare sig du är en företagare som behöver producera engagerande webbinnehåll, en student som arbetar på en avhandling, eller en författare som söker inspiration, kan vår AI-textgenerator hjälpa dig att uppnå dina mål snabbare och mer effektivt än någonsin tidigare.",
  //   icon: <KeyboardIcon />,
  //   video: { light: "/img/g-l.mp4", dark: "/img/g-d.mp4" },
  //   heroImage: {
  //     light: "/img/generera-text-hero-image-l.png",
  //     dark: "/img/generera-text-hero-image-l.png",
  //   },
  //   details: [
  //     {
  //       text: "Generera text: Använd vår kraftfulla AI för att snabbt skapa välskrivna textstycken om vilket ämne som helst, vilket sparar tid och ansträngning.",
  //       icon: <CreateIcon />,
  //     },
  //     {
  //       text: "Textanpassning: Anpassa den genererade texten efter dina behov genom att förkorta, förlänga eller omstrukturera innehållet.",
  //       icon: <TransformIcon />,
  //     },
  //     {
  //       text: "Ton och stil: Justera textens ton och stil genom att välja mellan formellt, informellt, akademiskt eller kreativt språkbruk för att matcha din önskade kommunikationsstil.",
  //       icon: <TuneIcon />,
  //     },
  //     {
  //       text: "Brainstorming: Utnyttja AI för att generera nya idéer och ämnen, baserat på befintlig text, vilket underlättar kreativt tänkande och innehållsutveckling.",
  //       icon: <LightbulbIcon />,
  //     },
  //     {
  //       text: "Spara dina texter: Håll dina genererade texter organiserade genom att spara dem i vår plattform, vilket gör det enkelt att återanvända eller referera till dem i framtiden.",
  //       icon: <SaveIcon />,
  //     },
  //   ],
  //   pros: [
  //     {
  //       text: "Effektiviserar skrivprocessen och sparar tid",
  //       icon: <AccessTimeIcon />,
  //     },
  //     {
  //       text: "Ger högkvalitativa texter anpassade efter dina behov",
  //       icon: <GradeIcon />,
  //     },
  //     {
  //       text: "Underlättar kreativt tänkande och innehållsutveckling",
  //       icon: <LightbulbIcon />,
  //     },
  //   ],
  //   steps: [
  //     {
  //       title: "Ange ämne eller nyckelord",
  //       description:
  //         "Börja med att ange det ämne eller de nyckelord du vill att AI:n ska skriva om.",
  //     },
  //     {
  //       title: "Anpassa inställningar",
  //       description:
  //         "Justera tonen, stilen, längden och andra preferenser för att skräddarsy texten efter dina behov.",
  //     },
  //     {
  //       title: "Generera och granska texten",
  //       description:
  //         "Låt AI:n skapa texten. Granska resultatet och gör eventuella justeringar eller be AI:n om ytterligare förbättringar.",
  //     },
  //   ],
  //   typeAnimationSequence: [
  //     "Skapa högkvalitativa texter med AI ",
  //     1000,
  //     "Effektivisera ditt skrivande ",
  //     1000,
  //     "Anpassa tonen och stilen ",
  //     1000,
  //     "Få inspiration och nya idéer ",
  //     1000,
  //     "Förbättra befintliga texter ",
  //     1000,
  //     "Spara tid och ansträngning ",
  //     1000,
  //   ],
  // },
  // {
  //   title: "Spara  i din egen anteckningsbok",
  //   description:
  //     "Spara frågor från högskoleprov, svar från en Chatbot eller en quiz-fråga",
  //   icon: <BookmarkIcon />,
  //   video: { light: "/img/s-l.mp4", dark: "/img/s-d.mp4" },
  //   goDirectlyToApp: true,
  //   details: [
  //     {
  //       text: "Personlig lagring: Håll all din studierelaterade information samlad genom att spara anteckningar och material från olika sektioner på ett ställe, vilket underlättar åtkomst och organisering.",
  //       icon: <LibraryBooksIcon />,
  //     },
  //     {
  //       text: "Filformat: Exportera dina sparade anteckningar och material i olika format såsom CSV, PDF eller Word, vilket ger dig flexibilitet att använda dem på det sätt som passar dig bäst.",
  //       icon: <FileDownloadIcon />,
  //     },
  //     {
  //       text: "Automatisk kategorisering: Låt systemet automatiskt organisera dina sparade material baserat på quiz, flashcards eller högskoleprov så att du snabbt kan hitta det du behöver.",
  //       icon: <CategoryIcon />,
  //     },
  //   ],
  // },

  {
    title: "Vi stödjer mängder av olika AI-modeller",
    description:
      "Generera studiematerial med olika Large Language Models (LLM)",
    video: { light: "/img/llm-l.mp4", dark: "/img/llm-d.mp4" },
    icon: <SchoolIcon />,
    goDirectlyToApp: true,
    models: [
      {
        name: "Studera.AI",
        description:
          "Vår egenutvecklade AI-modell som är specialdesignad för att erbjuda en anpassad och effektiv inlärningsupplevelse, skräddarsydd efter dina behov.",
      },
      {
        name: "Chat GPT 4o-mini",
        description:
          "En lättviktig version av GPT-4 som erbjuder snabba och effektiva svar, idealisk för enklare förfrågningar och när du behöver information snabbt.",
      },
      {
        name: "Chat GPT 4o",
        description:
          "Den fullständiga GPT-4-modellen som levererar avancerade och detaljerade svar, perfekt för komplexa frågor och djupgående analyser.",
      },
      {
        name: "Claude 3.5 Sonnet",
        description:
          "En sofistikerad AI-modell designad för att erbjuda djupare förståelse och insikter, vilket förbättrar din förmåga att hantera komplex information.",
      },
      {
        name: "Claude 3 Sonnet",
        description:
          "En effektiv AI-modell som är optimerad för snabb informationshantering och bearbetning, vilket underlättar din inlärningsprocess.",
      },
      {
        name: "Gemini Pro",
        description:
          "En AI-modell utrustad med avancerade analysfunktioner, idealisk för djupgående forskning och komplexa dataanalyser.",
      },
      {
        name: "Mistral Large",
        description:
          "En högpresterande AI-modell designad för att hantera komplexa problemlösningar och stora datamängder, vilket hjälper dig att lösa avancerade uppgifter.",
      },
    ],
  },
];

// export async function updateUserTokens(userId, tokens) {
//     const userDocRef = doc(db, "users", userId);

//     try {
//         await updateDoc(userDocRef, {
//             tokens: increment(tokens)
//         });
// Logger.log("Tokens successfully increased by ", tokens, " for user ", userId);
//     } catch (error) {
//         console.error("Error decreasing tokens: ", error);
//     }
// }
